import React, {  useEffect, useRef, useState } from "react";
import Select from "react-select";
import "react-datetime/css/react-datetime.css";
import Accordion from '../../accordion'
import { useHistory , useLocation } from "react-router";
import SignaturePad from "react-signature-canvas";


// ../../../../images/candidate/upload.png
//  download fill

import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
  Form,
  Input,
  UncontrolledTooltip,
  Col,
  Label,
  Tooltip,
  Modal,
  ModalBody,
  ModalFooter
} from "reactstrap";

import Upload from "../../../../images/candidate/upload.svg";
import pdf from "../../images/document.svg";



import { useFieldArray, useForm  } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import request, { NodeURL } from "../../../../api/api";





// custom componentssss

import { SelectInput, TextAreaInput,AddtionalFormFields, TextInput, RequiredTag, YESORNO, MobileNumberWithCode, DateInput, NumberInput, LocationSearchInput, MultipleCheckBox, NextButton, MultipleChoice, CheckBoxInput, UploadInput } from './UserInputs'
import moment from "moment";
import { countries, isValidDate, IsArray, languages, createFormData , scroll_to_top , validEmail , convertToISOString} from "../../../common/utils";
import { useProfilecontext } from "../Editprofileprovider";
import { initailState } from "../utils/profileReducer";
import { ImageViewModel } from "./ImageViewModel";
import { toast } from "react-toastify";
import RulesofImage from "./RulesofImage";


import "./new_profile.scss";






const addfileToServer = async (file = {}) =>{
    try {
    const res = await request({ url: "/candidate/form/addFilestoLocalDB", method: "POST", data:file,})
        return res.file_path ? res.file_path :''
    } catch (error) {
        return error;
    }
}

//employee/uploaded/file/delete
const deletefileFromServer = async (filePath = '') =>{
    try {
    const res = await request({ url: "/employee/uploaded/file/delete", method: "POST", data:{path:filePath},})
        return res.status;
    } catch (error) {
        return 0;
    }
}




const customStyles = {
    control: (base) => ({
        ...base,
        minHeight:"50px"
    }),
    menu: (base) => ({
        ...base,
        marginLeft: "0px", marginTop: "0px", fontSize: "14px", zIndex:9
    }),
    placeholder: (base) => ({
      ...base,
      fontSize:"14px"
    }),
    input: (defaultStyles) => {
        return {
            ...defaultStyles,
            padding: "0 22px",
            color: "#343434",
            outline: "none",
        }
    },

}





// Your Personal Details accordin id
export const personal_details_accordion_id = {
    "personal_details_1":0,
    "personal_details_2":1,
    "contact_address_details":2,
    "work_personal_details":3,
    "general_availability":4,
    "id_right_to_work":5,
	"driving_license_details":6,
	"language_details":7,
	"dbsdetails":8,
	"nextofcontact":9
}
// Employment & Education
const employment_education_accordion_id = {
    "qualification":0,
    "training_other_courses":1,
    "professional_body_memberships":2
}

// Declaration & Terms submenu tab 4 
const declaration_terms_accordion_id  = {
    working_time_regulation:0,
    health_declaration:1,
    personal_declaration:2,
    confidentiality:3,
    rehabilitation:4,
    disclosure_barring_service:5,
    health_safety:6,
    application_declaration:7
}



export default function ProfileTab({ isactivetab = ()=>{}, }) {

    const [active_accordion , setActiveAccordion ] = useState(personal_details_accordion_id['personal_details_1'])
    const [ state , dispatch ] = useProfilecontext();
    state.active_accordion = active_accordion;
    const { activeTab={} ,} = state;
    const domhistory = useHistory()




    useEffect(()=>{
        let { active_accordion,active_accordion_menu='' } = (domhistory.location && domhistory.location.state) || {};

        if(active_accordion){
            if(active_accordion_menu === 'employment_education'){
                toggleTab('submenu','2')
            }
            toggleAccordion(active_accordion,active_accordion_menu ? active_accordion_menu : undefined)
        }
    },[state.training_other_courses])


    const toggleAccordion = (id = '',accordin_menu = "personal_details") => {
		let accordin_section = {
			personal_details:personal_details_accordion_id,
            employment_education:employment_education_accordion_id,
            declaration_terms:declaration_terms_accordion_id
		}
        setActiveAccordion((prev)=>(accordin_section[accordin_menu] &&  accordin_section[accordin_menu][id]) || prev)
    }

    const handleSetToast = (id = '' , message = '' , type = '')=>{
        dispatch({type:"SET_TOAST" , payload:{ id, message , type}})
    }


    const toggleTab = (tab = '', tabId = '',) => {
        if(activeTab.submenu === tabId) return;
        dispatch({
            type:"TOGGLE_TAB",
            payload:{ tab , tabId }
        })
        setActiveAccordion(0)
        scroll_to_top()
    }

    const toggleImageViewer = (url='')=>{
        let url_path = String(url).startsWith('uploads/images') ? `${NodeURL}/${url}` : '';
        dispatch({type:"TOGGLE_IMAGE_VIEWER" , payload:{ viewUrl:url_path, /* isPreview:isPreview */  }})
        // setViewer((prev)=>({...prev ,TOGGLE_IMAGE_VIEWER viewUrl:url_path, isPreview:!prev.isPreview}))
    }

  return (
    <>
      <Nav tabs className="nav-pills nav-info horz-tab">

        <NavItem className="" id="" role="tablist">
          <NavLink
            className={isactivetab("submenu", "1") ? "active" : ""}
            onClick={() => toggleTab("submenu", "1")}
            disabled={false}
          >
            Your Personal Details
          </NavLink>
        </NavItem>

        <p>|</p>

        <NavItem className="" id="" role="tablist">
          <NavLink
            className={isactivetab("submenu", "2") ? "active" : ""}
            onClick={() => toggleTab("submenu", "2")}
            // disabled={true}
          >
            Employment {"&"} Education
          </NavLink>
        </NavItem>

        <p>|</p>

        <NavItem className="" id="" role="tablist">
          <NavLink
            className={isactivetab("submenu", "3") ? "active" : ""}
            onClick={() => toggleTab("submenu", "3")}
            // disabled={true}
          >
            Skills {"&"} Work History
          </NavLink>
        </NavItem>

        <p>|</p>


        <NavItem className="" id="" role="tablist">
          <NavLink
            className={isactivetab("submenu", "4") ? "active" : ""}
            onClick={() => toggleTab("submenu", "4")}
            // disabled={true}
          >
            Declaration {"&"} Terms
          </NavLink>
        </NavItem>

      </Nav>

      <TabContent activeTab={activeTab.submenu}>

        <TabPane tabId="1">
		{
		isactivetab("submenu", "1") &&
          <Accordion open={active_accordion} toggleAccordion={setActiveAccordion} >

            {/* active_accordion 0  */}
            <Accordion.Item>
              <Accordion.Header>Personal Details 1</Accordion.Header>
              <Accordion.Body>
                <PersonalDetailPrimary {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleImageViewer={toggleImageViewer}/>
              </Accordion.Body>
            </Accordion.Item>



            {/* active_accordion 1  */}
            <Accordion.Item >
              <Accordion.Header>Personal Details 2</Accordion.Header>
              <Accordion.Body>
                <PersonalDetailsecondary {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleImageViewer={toggleImageViewer} />
              </Accordion.Body>
            </Accordion.Item>





            <Accordion.Item>

              <Accordion.Header>Contact {"&"} Address Details</Accordion.Header>


              <Accordion.Body>
                <ContactaAndAddress {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleImageViewer={toggleImageViewer}  />
              </Accordion.Body>

            </Accordion.Item>

            <Accordion.Item>
              <Accordion.Header>Work {"&"} Personal Details</Accordion.Header>
              <Accordion.Body>

                <WorkAndPersonalDetails {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast}  toggleImageViewer={toggleImageViewer} />

              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item>
              <Accordion.Header>General Availability</Accordion.Header>
              <Accordion.Body>

                <GeneralAvailability {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleImageViewer={toggleImageViewer} />

              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item>
              <Accordion.Header>ID {"&"} Right to Work</Accordion.Header>
              <Accordion.Body>

                <IDAndRightToWork {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleImageViewer={toggleImageViewer}/>

              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item>
              <Accordion.Header>Driving License Details</Accordion.Header>
              <Accordion.Body>
				<DrivingLicenseDetails {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleImageViewer={toggleImageViewer}/>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item>
              <Accordion.Header>Language details</Accordion.Header>
              <Accordion.Body>
				<LanguageDetails {...state}  toggleAccordion={toggleAccordion} handleSetToast={handleSetToast}  />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item>
              <Accordion.Header>DBS Details</Accordion.Header>
              <Accordion.Body>
				<DBSDetails {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleImageViewer={toggleImageViewer}  />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item>
              <Accordion.Header>NEXT of KIN/EMERGENCY Contact</Accordion.Header>
              <Accordion.Body>
				<NextOfKin {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleTab={toggleTab} />
              </Accordion.Body>
            </Accordion.Item>



          </Accordion>
		}
          {/* <div className="position-relative col-12 col-md-12">
            <div className="text-center" id="s-c-buttons">
              <Button className="btn-save">Save</Button>
              <Button>Continue</Button>
            </div>
          </div> */}
        </TabPane>


        <TabPane tabId="2" className="emp_edu_sec">

          <Accordion open={active_accordion} toggleAccordion={setActiveAccordion}>
            <Accordion.Item>
              <Accordion.Header>Qualifications</Accordion.Header>
              <Accordion.Body>

				<Qualifications {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleTab={toggleTab}  />

              </Accordion.Body>
            </Accordion.Item>


            <Accordion.Item>
              <Accordion.Header>
                Training {"&"} Other Courses (Mandatory Training)
              </Accordion.Header>
              <Accordion.Body>

                <TraningAndCourse {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleTab={toggleTab}  />

              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item>
              <Accordion.Header>Professional Body Memberships</Accordion.Header>
              <Accordion.Body>
                
                <ProfessionalMemberships {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleTab={toggleTab}   />

              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          <div className="position-relative col-12 col-md-12">
            <div className="text-center three_button" id="s-c-buttons">
              <Button onClick={()=>toggleTab('submenu' , "1")}>
                <i class="fa fa-chevron-circle-left" aria-hidden="true"></i>{" "}
                Previous
              </Button>
              {/* <Button className="btn-save">Save</Button> */}
              {/* <Button>Continue</Button> */}
            </div>
          </div>
        </TabPane>



        <TabPane tabId="3">
            <SkillsAndWorkHistory  {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleTab={toggleTab} />          
        </TabPane>

        <TabPane tabId="4">
            
          <DeclarationTerms handleaccordion={setActiveAccordion}  {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleTab={toggleTab} open={active_accordion}  />

        </TabPane>


      </TabContent>
      <ImageViewModel filepath={state.viewUrl} toggle={toggleImageViewer} isOpen={state.isPreview}  />
    </>
  );
}




// const SaveAndContinue = ({}) =>{
//     return (
//         <div className="position-relative col-12 col-md-12">
//         <div className="text-center three_button" id="s-c-buttons">

//           <Button>
//             <i class="fa fa-chevron-circle-left" aria-hidden="true"></i>{" "}
//             Previous
//           </Button>

//           <Button className="btn-save">Save</Button>

//           <Button>Continue</Button>

//         </div>
//       </div>
//     )
// }














// yup schema for personal_details_1 section
const personal_details_primary_Schema = yup.object({
    title:yup.string(),
    firstname:yup.string().required("Required"),
    prefferedName:yup.string(),
    middlename:yup.string(),
    lastname:yup.string().required("Required"),
    maidenName:yup.string(),
    gender:yup.string().required("Required"),
    joining_date:yup.date(),
    isNameChanged:yup.string().oneOf(['yes' , 'no']),
    // if isNameChanged equal yes
    previousName:yup.string(),
    empBio:yup.string(),
    UploadIDPhoto:yup.string()

})


const MapFieldsValue = (addtionalFieldsValue = [])=>(item ={})=>{
    let value =  IsArray(addtionalFieldsValue) ? ( addtionalFieldsValue.find(it => it._id === item._id) || { value:''} ): { value:''};
    value = (value && value.value) || ""
    return {...item,value }
}


/* {
    "_id": "649c0a10e7d7a11384a8bd82",
    "field_type": "Dropdown",
    "sub_fields": [
        "Mr.",
        "Mrs.",
        "Miss.",
        "Ms.",
        "Dr.",
        "Prof.",
        "Rev."
    ],
    "buildIn": "static",
    "field_name": "Title",
    "field_menu": {
        "name": "Your Personal Details",
        "id": "649aa68ae7bf5a1f6cecdba9"
    },
    "field_heading": {
        "name": "Personal Details 1",
        "id": "649abe8d1dea64166066417e"
    },
    "template": {
        "isView": true,
        "templateValue": "",
        "_id": "6529450dc52c322514e07b5f",
        "templateid": "64f96992c4fa6c2088662a06",
        "heading": ""
    },
    "field_required": true
} */
const StaticFieldsProps = ({staticFields=[], label='' , render=()=>{}}) =>{
    // return IsArray(staticFields) && staticFields.find((item={})=>)
    let fieldData =  IsArray(staticFields) ? staticFields.find((item={})=>item.field_name === label) : null
    return fieldData ? render(fieldData) || <></> : <></>
}


const PersonalDetailPrimary = React.memo((props = {}) => {

    // const personal_details_2
    let { toggleAccordion , handleSetToast , updateForm=()=>{} , staticFields = [] , addtionalFields = [] , addtionalFieldsValue =[] , toggleImageViewer=()=>{}} = props ;

    const [ imageRules , setImageRules ] = useState(false);

    let required_addtionalfields = [];
    let userFields = IsArray(addtionalFields) ? addtionalFields.filter((item={}) => item.field_heading.name === 'Personal Details 1') : [];
        userFields = userFields.map(MapFieldsValue(addtionalFieldsValue));
        userFields.forEach((item = {})=>item.field_required && required_addtionalfields.push({ name:item.field_name,required:item.field_required ,type:item.field_type  }) );
    let userStaticFields = IsArray(staticFields) ? staticFields.filter((item={})=>item.field_heading && item.field_heading.name === 'Personal Details 1') : [];

    
    const { register , handleSubmit ,watch , formState , getValues , setValue , control } = useForm({
        // resolver:yupResolver(personal_details_primary_Schema),
        values:{
            title:props.title || "",
            firstname:props.firstname || '',
            prefferedName:props.prefferedName || "",
            middlename:props.middlename || '',
            lastname:props.lastname || '',
            maidenName:props.maidenName || "",
            gender:props.gender || "",
            joining_date:props.joining_date || '',
            isNameChanged:props.isNameChanged || "",
            // if isNameChanged equal yes
            previousName:props.previousName || "",
            empBio:props.empBio || '',
            UploadIDPhoto:props.UploadIDPhoto || "",
            addtionalFields:userFields
        },
        
    }),
    {errors ,isValid ,  } = formState ;

    const { fields ,  } = useFieldArray({ name:"addtionalFields" ,control })

    const [profileImg , setProfileImg] = useState(null);


    const toggleRulesofImage = () =>{
        setImageRules((prev)=>!prev)
    }
    const handleOnDateChange = (e ='' ,name='') => {
        let _date = isValidDate(e) ? moment(e): '';
        isValidDate(e) &&  setValue(name,_date)
    }
    const handeleUploadIDPhotoChange = (e ={}) =>{
        let file = e.target && e.target.files[0];
        if(!file) return;
        setProfileImg(file)
        const filePath = URL.createObjectURL(file)
        filePath && setValue("UploadIDPhoto" , filePath)

    }

    const onFormSubmit = async (data={})=>{
        // if(!formState.isDirty){
        //     // handleSetToast && handleSetToast("formupdate" ,  ,"success")
        //     return toggleAccordion && toggleAccordion("personal_details_2" ,"personal_details");
        // }
        let body = {...data};
        body.previousName = body.previousName === "undefined" ? '' : body.previousName;
        body.joining_date = convertToISOString(body.joining_date)

        if(profileImg instanceof File){
            body.UploadIDPhoto = profileImg;
        }else{
            delete body.UploadIDPhoto;
        }
        body.addtionalFields = body.addtionalFields.map((item ={})=>({
            field_heading:item.field_heading.name ,
            field_menu:item.field_menu.name ,
            field_type:item.field_type, 
            value: (item.field_type ==="date") ?   (item.value) : item.value, 
            _id:item._id 
        }))
        body.addtionalFields =  JSON.stringify(IsArray(body.addtionalFields)? body.addtionalFields : [])
        

        const personalData = createFormData({...body ,setctionId:"personal_details_1" });
        if(updateForm){
            updateForm(personalData).then((res)=>{

                handleSetToast && handleSetToast("formupdate" , (res && res.response) ,"success")
                toggleAccordion && toggleAccordion("personal_details_2" ,"personal_details");
            })
        }
    }

    // ["pdf" , "png" ,"jpeg" ,"jpg"].includes(temp1.type))slice('dddddimage/png'.search("/"))
    const handleIDFiles = async (e = {} ,type = '') =>{
        let files = (e && e.target && e.target.files) ? e.target.files : [];
            files = files.length ? files[0] : null;

        if(!files) return;
        if(!(files.size < 5242880)){
            return toast.error("Maximum upload size is 5MB");
        }
        if(!["pdf" , "png" ,"jpeg" ,"jpg"].includes(files.type.slice(files.type.search("/") + 1))){
            return toast.error("File Format not supported");
        }
            let data = createFormData({upload_doc : files})
            let url = await addfileToServer(data);
            if(url){
                if(type === "rightToWork_doc_url"){
                    return setValue("rightToWork_doc_url" , url)
                }
                setValue("doc_url" ,[...getValues('doc_url') , url])
                // toast.success("File Saved!")
            }


    }

    

    return (
        <>
            <RulesofImage isOpen={imageRules} toggle={toggleRulesofImage} />
                
            <Form onSubmit={handleSubmit(onFormSubmit )} >
                
                {/* <SelectInput label="Title" options={["Mr.", "Mrs.", "Miss.", "Ms.", "Dr.", "Prof.", "Rev."]} {...register("title")} /> */}
                {/* <TextInput error={errors.firstname && errors.firstname.message} required label='First name' placeholder="First name" {...register("firstname" , { required:{ value:true ,message:"Required" } })} /> */}
                {/* <TextInput error={errors.prefferedName && errors.lastname.message} label="Preferred Name" placeholder="Preferred Name" {...register("prefferedName")} /> */}
                {/* <TextInput error={errors.middlename && errors.middlename.message} label="Middle Name" placeholder="Middle Name" {...register("middlename")} /> */}
                {/* <TextInput error={errors.lastname && errors.lastname.message} required label="Last Name" placeholder="Last Name" {...register("lastname", { required:{ value:true ,message:"Required" } })} /> */}
                {/* <TextInput error={errors.maidenName && errors.maidenName.message} label="Maiden Name" placeholder="Maiden Name" {...register("maidenName")} /> */}
                {/* <SelectInput label={"Gender"} placeholder="Genter" options={['Male', "Female"]} {...register("gender", { required:{ value:true ,message:"Required" } })} error={errors.gender && errors.gender.message} /> */}


                <StaticFieldsProps label="Title" staticFields={userStaticFields} render={(field={})=>{
                    return <SelectInput label={field.field_name} required={field.field_required} options={field.sub_fields|| []} {...register("title" ,{...(field.field_required) && {validate:(v)=>Boolean(v) ||"Required"} } )} error={errors.title && errors.title.message}/>
                }} />

                <StaticFieldsProps label="First Name" staticFields={userStaticFields} render={(field={})=>{
                    return <TextInput error={errors.firstname && errors.firstname.message} required={field.field_required} label='First Name' placeholder="First Name" {...register("firstname" , {...(field.field_required) && {validate:(v)=>Boolean(v) ||"Required"} } )} />
                }} />

                <StaticFieldsProps label="Preferred Name" staticFields={userStaticFields} render={(field={})=>{
                    return <TextInput error={errors.prefferedName && errors.prefferedName.message} required={field.field_required} label="Preferred Name" placeholder="Preferred Name" {...register("prefferedName", {...(field.field_required) && {validate:(v)=>Boolean(v) ||"Required"} })} />
                }} />

                <StaticFieldsProps label="Middle Name" staticFields={userStaticFields} render={(field={})=>{
                    return <TextInput error={errors.middlename && errors.middlename.message} required={field.field_required} label="Middle Name" placeholder="Middle Name" {...register("middlename", {...(field.field_required) && {validate:(v)=>Boolean(v) ||"Required"} })} />
                }} />

                <StaticFieldsProps label="Last Name" staticFields={userStaticFields} render={(field={})=>{
                    return <TextInput error={errors.lastname && errors.lastname.message} required={field.field_required} label="Last Name" placeholder="Last Name" {...register("lastname", {...(field.field_required) && {validate:(v)=>Boolean(v) ||"Required"} })} />
                }} />

                <StaticFieldsProps label="Maiden Name" staticFields={userStaticFields} render={(field={})=>{
                    return <TextInput error={errors.maidenName && errors.maidenName.message} required={field.field_required} label="Maiden Name" placeholder="Maiden Name" {...register("maidenName", {...(field.field_required) && {validate:(v)=>Boolean(v) ||"Required"} })} />
                }} />

                <StaticFieldsProps label="Have you ever changed your name ?" staticFields={userStaticFields} render={(field={})=>{
                    return <>
                        <YESORNO label="Have you ever changed your name ?" name="isNameChanged" required={field.field_required} register={register} />
                        {
                            watch("isNameChanged") === 'yes'
                            ? <TextInput error={errors.previousName && errors.prefferedName.message} label="Previous Name" placeholder="Previous Name" {...register("previousName")} />
                            : <></>
                        }
                    </>
                }} />

                <StaticFieldsProps label="Gender" staticFields={userStaticFields} render={(field={})=>{
                    return <SelectInput label={field.field_name} required={field.field_required} options={field.sub_fields|| []} {...register("gender" ,{...(field.field_required) && {validate:(v)=>Boolean(v) ||"Required"} } )} error={errors.gender && errors.gender.message}/>
                }} />


                <StaticFieldsProps label="Date Joined" staticFields={userStaticFields} render={(field={})=>{
                    return <DateInput label={field.field_name}  name="joining_date" required={field.field_required} options={field.sub_fields|| []} handleOnDateChange={handleOnDateChange} value={watch("joining_date")}  error={errors.joining_date && errors.joining_date.message}/>
                }} />

                <div className="position-relative col-12 col-md-4">
                    <div className="form-group drag_sec">
                    {
                            <>
                                <p>Upload Profile Image</p>
                                <div className="drag_drop ">
                                    <span className={`profile-upload ${getValues("UploadIDPhoto") && "d-none"} `} >
                                        <Input type="file" accept="image/*" onChange={handeleUploadIDPhotoChange} />
                                        <img src={Upload} alt="Upload" />
                                        <p>
                                            Drag and Drop the image
                                            <br />
                                            (or)
                                        </p>
                                        <span>Browse</span>
                                    </span>

                                   { getValues("UploadIDPhoto") && <img className="w-100 prolile-image" src={getValues("UploadIDPhoto").startsWith('uploads/images') ? `${NodeURL}/${getValues("UploadIDPhoto")}` : getValues("UploadIDPhoto")} alt="Profile" /> }
                                </div>
                            </>
                    }

                        <span onClick={toggleRulesofImage}> <i>Rules For Photos</i> </span>

                    </div>

                </div>

                {/* <TextAreaInput label="About Me" {...register("empBio")}/> */}
                <StaticFieldsProps label="About Me" staticFields={userStaticFields} render={(field={})=>{
                    return <TextAreaInput label={field.field_name} required={field.field_required} {...register("empBio" ,{...(field.field_required) && {validate:(v)=>Boolean(v && v.replace(/(?:^\s+|\s+$)/g ,'')) ||"Required"} } )} error={errors.empBio && errors.empBio.message}/>
                }} />
                
                {/* Addtional Fields for the section personal details  */}
                <AddtionalFormFields 
                    fields={fields}  
                    register={register} 
                    handleOnDateChange={handleOnDateChange} 
                    watch={watch} 
                    errors={errors} 
                    toggleImageViewer={toggleImageViewer}
                    setValue={setValue}
                    getValues={getValues}
                />
             
                {/* <UploadInput file_list={['uploads/images/employee/1554276204681.png']} toggleImageViewer={toggleImageViewer} /> */}

                <NextButton />
            </Form>
        </>
    )
})




const personal_details_secondary_Schema = yup.object({
    dateofbirth:yup.string().required("Required"),
    martialStatus:yup.string(),
    insuranceno:yup.string(),
    nationality:yup.string(),
    religion:yup.string(),
})

const PersonalDetailsecondary = React.memo((props = {}) => {

    const { toggleAccordion , handleSetToast , updateForm = ()=>{}, staticFields=[] , addtionalFields=[] , addtionalFieldsValue=[], toggleImageViewer=()=>{}} = props ;

    let required_addtionalfields = [];
    let userFields = IsArray(addtionalFields) ? addtionalFields.filter((item={}) => item.field_heading.name === 'Personal Details 2') : [];
        userFields = userFields.map(MapFieldsValue(addtionalFieldsValue));
        userFields.forEach((item = {})=>item.field_required && required_addtionalfields.push({ name:item.field_name,required:item.field_required ,type:item.field_type }));
    let userStaticFields = IsArray(staticFields) ? staticFields.filter((item={})=>item.field_heading && item.field_heading.name === 'Personal Details 2') : [];


    const { register , handleSubmit ,watch , formState  , setValue , getValues , control } = useForm({
        // resolver:yupResolver(personal_details_secondary_Schema),
        values:{
            dateofbirth:props.dateofbirth,
            martialStatus:props.martialStatus,
            insuranceno:props.insuranceno,
            nationality:props.nationality,
            religion:props.religion,
            addtionalFields:userFields
        }
    }),
    {errors ,isValid ,  } = formState ;
    const { fields ,  } = useFieldArray({ name:"addtionalFields" ,control })

    const handleOnDateChange = (e ='' ,name='') => {
        let _date = isValidDate(e) ? moment(e): '';
        isValidDate(e) &&  setValue(name,_date , {shouldDirty:true})
    }

    const handleOnSelect = (e , name = '') =>{
        let value = (e && e.value) || ""
        name && setValue(name ,value , {shouldDirty:true})
    }


    const onFormSubmit = async (data={})=>{
        const body = {...data};
        body.dateofbirth = convertToISOString(body.dateofbirth)
        body.addtionalFields =  JSON.stringify(IsArray(body.addtionalFields)? body.addtionalFields : [])
        const personalData = {...body ,setctionId:"personal_details_2" };
        if(updateForm){
            updateForm(personalData).then((res)=>{
                handleSetToast && handleSetToast("formupdate" , (res && res.response) ,"success")
                toggleAccordion && toggleAccordion("contact_address_details" , "personal_details")
            })
        }
    }


    return <Form onSubmit={handleSubmit(onFormSubmit)}>

        {/* <DateInput label="Date Of Birth" name="dateofbirth" required handleOnDateChange={handleOnDateChange} value={watch("dateofbirth")} isValidDate={(current = moment()) =>current.isBefore(moment(new Date()).subtract(16,"years"))} /> */}
        {/* <SelectInput label='Marital Status' placeholder="Marital Status" options={["Single", "Married", "Divorced", "Widowed" ]} lowercase={false} {...register("martialStatus")} /> */}
        {/* <SelectInput label="Religion" placeholder='Religion' options={["Bhudist" ,"Christian" ,"Jewish" , 'Hindu' ,"Muslim" ,'Sikh' ,'Other']} {...register("religion")} /> */}



        <StaticFieldsProps label="Date Of Birth" staticFields={userStaticFields} render={(field={})=>{
            return <DateInput 
                      label={field.field_name}  
                      name="dateofbirth" 
                      required={field.field_required} 
                    //   options={field.sub_fields|| []} 
                      handleOnDateChange={handleOnDateChange} 
                      value={watch("dateofbirth")}  error={errors.dateofbirth && errors.dateofbirth.message} 
                      isValidDate={(current = moment()) =>current.isBefore(moment(new Date()).subtract(16,"years"))}
                    />
        }} />

        <StaticFieldsProps label="Marital Status" staticFields={userStaticFields} render={(field={})=>{
            return <SelectInput 
                      label={field.field_name} 
                      required={field.field_required}
                      options={field.sub_fields|| []}
                      lowercase={false} 
                      {...register("martialStatus" ,{...(field.field_required) && {validate:(v)=>Boolean(v) ||"Required"} } )} 
                      error={errors.martialStatus && errors.martialStatus.message} 
                    />
        }} />

        <StaticFieldsProps label="National Insurance No" staticFields={userStaticFields} render={(field={})=>{
            return <TextInput 
                      label="National Insurance No" 
                      placeholder="National Insurance No" 
                      {...register("insuranceno", {...(field.field_required) && {validate:(v)=>Boolean(v) ||"Required"} })} 
                      required={field.field_required} 
                      error={errors.insuranceno && errors.insuranceno.message} 
                      />
        }} />

        {/* React select input  */}
        <div className="position-relative col-12 col-md-4">
            <div className="form-group select_box">
                    <Select
                        options={countries}
                        className={"select-box"}
                        classNamePrefix={"select-class"}
                        styles={customStyles}
                        isClearable={true}
                        onChange={(e)=>handleOnSelect(e , "nationality")}
                        value={countries.find(i=>i.value=== watch("nationality"))}

                    />
                <label>Nationality</label>
            </div>
        </div>

        <StaticFieldsProps label="Religion" staticFields={userStaticFields} render={(field={})=>{
            return <SelectInput 
                      label={field.field_name}
                      placeholder={field.field_name}
                      required={field.field_required} 
                      options={field.sub_fields|| []} 
                      {...register("religion" ,{...(field.field_required) && {validate:(v)=>Boolean(v) ||"Required"} } )} 
                      error={errors.religion && errors.religion.message} 
                    />
        }} />


        {/* Addtional Fields for the section personal details  */}
        <AddtionalFormFields 
            fields={fields}  
            register={register} 
            handleOnDateChange={handleOnDateChange} 
            watch={watch} 
            errors={errors}
            toggleImageViewer={toggleImageViewer}
            setValue={setValue}
            getValues={getValues}
        />

        <NextButton />
    </Form>


})


{/* <NumberInput key={item.id} required={field_required} label={field_name} placeholder={field_name} {...register(name ,{...(field_required) && {validate:(v)=>Boolean(v) ||"Required"} } )} error={error} /> */}
const contact_address_Schema = yup.object({
    email:yup.string().email('Incorrect Email').required('Incorrect Email'),
    "number": yup.string().required("Required"),
    "code":yup.string(),
    "dialcountry": yup.string().default("gb"),
    homephone:yup.string(),
    addressline2:yup.string(),
    streetAddress:yup.string(),
    city:yup.string(),
    state:yup.string(),
    zip:yup.string(),
    country:yup.string(),
    dateMovedAddress:yup.string(),

});



const ContactaAndAddress = (props = initailState) => {


    // contact_address_details
    const { toggleAccordion , handleSetToast ,addtionalFields = [] ,addtionalFieldsValue = [] ,toggleImageViewer=()=>{} ,active_accordion} = props ;
    const [ {  updateForm, ...state} ,dispatch ] = useProfilecontext()

    let required_addtionalfields = [];
    let userFields = IsArray(addtionalFields) ? addtionalFields.filter((item={}) => item.field_heading.name === 'CONTACT AND ADDRESS DETAILS') : [];
        userFields = userFields.map(MapFieldsValue(addtionalFieldsValue));
        userFields.forEach((item = {})=>item.field_required && required_addtionalfields.push({ name:item.field_name,required:item.field_required ,type:item.field_type  }))


    const { register , handleSubmit ,watch , formState , setError ,clearErrors , setValue , control ,getValues } = useForm({
        // resolver:createYupSchema(yupResolver(contact_address_Schema) ,Fields.filter((item= {}) => item.field_required ).map(item => item.field_name) ),
        values:{
            "number": props.mobileno.number,
            "code": props.mobileno.code,
            "dialcountry": props.mobileno.dialcountry || 'gb' ,
            email:props.email,
            homephone:props.homephone,
            streetAddress:props.streetAddress,
            addressline2:props.addressline2,
            city:props.city,
            state:props.state,
            zip:props.zip,
            country:props.country,
            dateMovedAddress:props.dateMovedAddress,
            addtionalFields:userFields,
            uploadAddressProof:props.uploadAddressProof,
        }
    }),
    {errors ,isValid ,  } = formState ;
        
    const { fields ,  } = useFieldArray({ name:"addtionalFields" ,control });

    const streetAddress  = register("streetAddress");
    const number = register("number" ,{required:"Incorrect Mobile",value:props.mobileno.number})
    const uploadAddressProof = register("uploadAddressProof" ,{required:"Please upload file"})

    let _watch_proof_addressFile = watch("uploadAddressProof",[])
    let _watch_code = watch("code",'')
    let _watch_number = watch("number",props.mobileno.number)
    let _watch_streetAddress = watch("streetAddress",'')
    const [uploadTooltip ,setUploadTooltip] = useState(false)



    // reducers  state 
    const SET_STATE = (payload ={})=>{
        dispatch({type:"SET_STATE" , payload})
    }


    useEffect(()=>{
        console.log(errors ,_watch_proof_addressFile ,'errors')
        setUploadTooltip(Boolean(active_accordion===2 && errors.uploadAddressProof && errors.uploadAddressProof.message && !_watch_proof_addressFile.length))
    },[errors,_watch_proof_addressFile ,active_accordion])


    // data handlerrr
    const handleOnDateChange = (e ='' ,name='') => {
        let _date = isValidDate(e) ? moment(e): '';
        isValidDate(e) &&  setValue(name,_date , {shouldDirty:true})
    }

    const handleOnAddressSelect = (data = {} , res)=>{
        const {  addressline1 = "" ,addressline2 = "" ,city = "" ,state = "" ,country = "" ,zip  = "" } = data;
         setValue("streetAddress" , addressline1 , {shouldDirty:true});
         setValue("addressline2" , addressline2 , {shouldDirty:true});
         setValue("city" , city , {shouldDirty:true});
         setValue("state" , state , {shouldDirty:true});
         setValue("country" , country , {shouldDirty:true});
         setValue("zip" , zip , {shouldDirty:true});


    }

    const handleOnMobileChange = (status , value ='', country={} ,) =>{
        if(!status){
            setError("number",{message:"Invalid Mobile"},)
        }else{
            clearErrors("number")
        }
        setValue("number" , value , {shouldDirty:true})
        setValue("dialcountry" , country.dialCode , {shouldDirty:true})
        setValue("code" , country.iso2 , {shouldDirty:true})
    }
    // #dc3545
    const handleSelectFlag = (value ="" ,country={}) =>{
        setValue("dialcountry" , country.dialCode , {shouldDirty:true})
        setValue("code" , country.iso2 , {shouldDirty:true})
        setValue("number" , value , {shouldDirty:true})
    }

    const handleFiles = async (e = {} ,type = '') =>{
        let files = (e && e.target && e.target.files) ? e.target.files : [];
            files = files.length ? files[0] : null;

        if(!files) return;
        if(!(files.size < 5242880)){
            return toast.error("Maximum upload size is 5MB");
        }
        if(!["pdf" , "png" ,"jpeg" ,"jpg"].includes(files.type.slice(files.type.search("/") + 1))){
            return toast.error("File Format not supported");
        }
            // console.log(files, '_watch_drivingFiles')
            let data = createFormData({upload_doc : files})
            let url = await addfileToServer(data);
            if(url && _watch_proof_addressFile){
                setValue("uploadAddressProof" ,[..._watch_proof_addressFile , { name:files.name,path:url }],{shouldDirty:true})
                // toast.success("File Saved!")
            }
    }
    const handleFilesDelete = (path ="" , type = "") => {
        let uploadAddressProofnew = _watch_proof_addressFile.filter(i => i.path !== path);
        setValue("uploadAddressProof" , uploadAddressProofnew);

    }

    const onFormSubmit = async (data={})=>{

        const body = {...data};
        body.addtionalFields = body.addtionalFields.map((item ={})=>({
            field_heading:item.field_heading.name ,
            field_menu:item.field_menu.name ,
            field_type:item.field_type, 
            value: (item.field_type ==="date") ? convertToISOString(item.value) : item.value, 
            _id:item._id 
        }))
        body.addtionalFields =  JSON.stringify(IsArray(body.addtionalFields)? body.addtionalFields : [])
        let uploadAddressProof = JSON.stringify(IsArray(data.uploadAddressProof) ? data.uploadAddressProof : []);
        const personalData = ({...body,uploadAddressProof,setctionId:"contact_address_details"});
        if(updateForm){
            updateForm(personalData).then((res)=>{
                SET_STATE({...data ,mobileno:{ number:data.number , code:data.code , dailcountry:data.dailcountry }  })
                handleSetToast && handleSetToast("formupdate" , (res && res.response) ,"success")
                toggleAccordion && toggleAccordion("work_personal_details" ,"personal_details")
            })
        }
    }

    return <Form onSubmit={handleSubmit(onFormSubmit)}>

        <TextInput label='Email Address' placeholder='Email Address' required error={errors.email && errors.email.message} {...register('email' , { validate:(v)=>validEmail(v) || "Incorrect Email"  })}/>

        {/* <NumberInput label='Mobile No' placeholder='Mobile No' required error={errors.number && errors.number.message  } {...register("number")} /> */}
        <MobileNumberWithCode defaultCountry={_watch_code} handleSelectFlag={handleSelectFlag} handleOnchange={handleOnMobileChange} error={errors.number && errors.number.message} required label="Mobile No" value={_watch_number} ref={number.ref}  />
        
        <NumberInput label='Home Phone' placeholder='Home Phone' error={errors.homephone && errors.homephone.message} {...register('homephone')} />

        {/* <TextInput label='House/Flat/Building' placeholder='House/Flat/Building' error={errors.streetAddress && errors.streetAddress.message} {...register('streetAddress')} /> */}

        <LocationSearchInput onSelect={handleOnAddressSelect} label="House/Flat/Building" ref={streetAddress.ref} handleOnchange={(e)=>setValue("streetAddress" ,e)} value={_watch_streetAddress} />

        <TextInput label='Address Line 2' placeholder='Address Line 2' error={errors.addressline2 && errors.addressline2.message} {...register('addressline2')} />

        <TextInput label='City' placeholder='City' error={errors.city && errors.city.message} {...register("city")} />

        <TextInput label="State / Region" placeholder="State / Region" error={errors.state && errors.state.message} {...register("state")} />

        <TextInput label="ZIP / Postal Code" placeholder="ZIP / Postal Code" error={errors.zip && errors.zip.message} {...register("zip")} />

        <TextInput label="Country" placeholder="Country" error={errors.country && errors.country.message} {...register("country")} />

        <DateInput name="dateMovedAddress" label="Date moved to this address" handleOnDateChange={handleOnDateChange} value={watch("dateMovedAddress")} />

        {/* Addtional Fields for the section personal details  */}
        <AddtionalFormFields 
            fields={fields}  
            register={register} 
            handleOnDateChange={handleOnDateChange} 
            watch={watch} 
            errors={errors}
            toggleImageViewer={toggleImageViewer}
            setValue={setValue}
            getValues={getValues}
        />

        <div className="position-relative col-3 col-md-1 file_join">
            <div className="form-group doc-list">
                <div className="edit-upload-file">
                    <label id="addressFile_file_upload">
                    <img  src={Upload} style={{cursor:'pointer'}} alt="" /* className={`${upload_isdisable ? "" : 'uploadfile-disabled'}`}  */ />
                        <input className="d-none" /* disabled={!upload_isdisable} */ type="file" accept="application/pdf,.pdf,image/*" onChange={handleFiles} />
                        <Tooltip placement='right' className="uploadTooltip" isOpen={uploadTooltip} target="addressFile_file_upload" toggle={()=>{}} >Please upload file</Tooltip>
                    </label>
                </div>
            </div>                                
        </div>

        <div className="position-relative col-2 col-md">
            <div className="form-group doc-list">
                <ul>
                    {
                        IsArray(_watch_proof_addressFile)
                        ? _watch_proof_addressFile.map((item = {})=>item.path.startsWith('uploads/images') ? <FileViewDoc key={item.path} url={item.path} onClick={()=>toggleImageViewer(item.path)} onDelete={()=>handleFilesDelete(item.path)} /> : null )
                        : <></>
                    }
                </ul>
            </div>
        </div>

        <NextButton />
    </Form>
}




const work_And_personal_detailsSchema = yup.object({
    job_type:yup.array().min(1).required("Job is Required!"),
    locations:yup.array().min(1).required("Area is Required!"),
    workstatus:yup.string()
})

const WorkAndPersonalDetails = (props = initailState) => {

    const { toggleAccordion , handleSetToast , updateForm , addtionalFields = [] ,addtionalFieldsValue=[] , worklist:locationsList = [] , jobtypelist =[] , toggleImageViewer=()=>{}} = props ;

    let required_addtionalfields = [];
    let userFields = IsArray(addtionalFields) ? addtionalFields.filter((item={}) => item.field_heading.name === 'WORK & PERSONAL DETAILS') : [];
        userFields = userFields.map(MapFieldsValue(addtionalFieldsValue));
        userFields.forEach((item = {})=>item.field_required && required_addtionalfields.push({ name:item.field_name,required:item.field_required ,type:item.field_type  }))


    const { register , handleSubmit ,watch , formState , getValues , setValue , control } = useForm({
        // resolver:yupResolver(work_And_personal_detailsSchema),
        values:{
            locations:props.locations,
            workstatus:props.workstatus === "Please Select" ? "" : props.workstatus,
            job_type:props.job_typeValue,
            addtionalFields:userFields
        }
    }),
    {errors ,  } = formState ;
    const { fields ,  } = useFieldArray({ name:"addtionalFields" ,control })


    const handleOnSelect = (e , name = '') =>{
        // let value = (e && e.value) || ""
        name && setValue(name ,e , {shouldDirty:true})
    }

    const handleOnDateChange = (e ='' ,name='') => {
        let _date = isValidDate(e) ? moment(e): '';
        isValidDate(e) &&  setValue(name,_date , {shouldDirty:true})
    }

    const onFormSubmit = async (data={}) => {
        // if(!formState.isDirty){
        //     return toggleAccordion && toggleAccordion("general_availability" ,"personal_details");
        // }
        let body = {};
        body.job_type = IsArray(data.job_type) ? data.job_type.map((i = {}) => i.value) : []
        body.job_type_name = IsArray(data.job_type) ? data.job_type.map((i = {}) => i.label) : [];

        body.locations = IsArray(data.locations) ? data.locations.map((i = {}) => i.value) : [];
        body.locations_name = IsArray(data.locations) ? data.locations.map((i = {}) => i.label) : [];
        body.workstatus = data.workstatus;
        body.addtionalFields =  IsArray(data.addtionalFields) ? data.addtionalFields.map((item ={})=>({
            field_heading:item.field_heading.name ,
            field_menu:item.field_menu.name ,
            field_type:item.field_type, 
            value: (item.field_type ==="date") ? convertToISOString(item.value) : item.value, 
            _id:item._id 
        })) 
        : [];
        body.addtionalFields =  JSON.stringify(IsArray(body.addtionalFields)? body.addtionalFields : [])


        const personalData = createFormData({...body ,setctionId:"work_personal_details"});
        if(updateForm ){
            updateForm(personalData).then((res)=>{
                handleSetToast && handleSetToast("formupdate" , (res && res.response) ,"success")
                toggleAccordion && toggleAccordion("general_availability" ,"personal_details");
            })
        }
    }



    return <Form onSubmit={handleSubmit(onFormSubmit)}>

        <div className="position-relative col-12 col-md-4">
            <div className="form-group select_box">
                <Select
                    options={jobtypelist}
                    styles={customStyles}
                    isMulti
                    value={watch("job_type")}
                    onChange={(e)=>handleOnSelect(e ,'job_type')}
                    ref={register("job_type").ref}
                    // className="inva"
                    />
                <label>Job Role <RequiredTag required display="inline" /> </label>
                {
                    errors.job_type && errors.job_type.message &&
                    <div class="invalid-feedback" style={{display:"contents"}} >Job is Required<i class="fa fa-exclamation-circle" aria-hidden="true"></i> </div>
                }
            </div>
        </div>

        <div className="position-relative col-12 col-md-4">
            <div className="form-group select_box">
                <Select
                    options={locationsList}
                    className={"select-box"}
                    classNamePrefix={"select-class"}
                    styles={customStyles}
                    value={watch("locations")}
                    onChange={(e)=>handleOnSelect(e ,'locations')}
                    isMulti
                    ref={register("locations").ref}

                />
                <label>Area <RequiredTag required display="inline" /> </label>
                {
                    errors.locations && errors.locations.message &&
                    <div class="invalid-feedback" style={{display:"contents"}} >Area is Required<i class="fa fa-exclamation-circle" aria-hidden="true"></i> </div>
                }
            </div>
        </div>

        <SelectInput label="Work Status" options={['PAYE' ,"Self Employed" ,"Not sure"]} {...register('workstatus')} trim={true}/>
       
        {/* Addtional Fields for the section personal details  */}
        <AddtionalFormFields 
            fields={fields}  
            register={register} 
            handleOnDateChange={handleOnDateChange} 
            watch={watch} 
            errors={errors} 
            toggleImageViewer={toggleImageViewer}
            setValue={setValue}
            getValues={getValues}
        />

        <NextButton />

    </Form>
}








// General Availability




let abletowork = ['Anytime' , 'Mornings', 'Evenings' ,'Afternoons', 'Occasional Weeks' , 'Full Time' ,'Part Time', 'Nights' , 'Weekends'],
    abletowork_name = {
        "Anytime":"work_anytime",
        "Mornings":"work_mornings",
        "Evenings":"work_evenings",
        "Afternoons":"work_afternoons",
        "Occasional Weeks":"work_occasional",
        'Full Time':"work_fulltime",
        'Part Time':"work_parttime",
        "Nights":"work_nights",
        'Weekends':"work_weekends"
    };


const general_availabilitySchema = yup.object({
    work_mornings:yup.bool(),
    work_evenings:yup.bool(),
    work_afternoons:yup.bool(),
    work_occasional:yup.bool(),
    work_parttime:yup.bool(),
    work_fulltime:yup.bool(),
    work_nights:yup.bool(),
    work_weekends:yup.bool(),
    work_anytime:yup.bool(),
    availablestartdate:yup.string().required("Incorrect Date"),
    shortnotice:yup.string(),
    reduceworkflexibility:yup.string(),
    workstate:yup.string(),
})

const GeneralAvailability = (props = initailState) => {



    const { toggleAccordion , handleSetToast , updateForm , addtionalFields=()=>{},addtionalFieldsValue=()=>{},toggleImageViewer=()=>{}} = props ;

    let required_addtionalfields = [];
    let userFields = IsArray(addtionalFields) ? addtionalFields.filter((item={}) => item.field_heading.name === 'General Availability') : [];
        userFields = userFields.map(MapFieldsValue(addtionalFieldsValue));
        userFields.forEach((item = {})=>item.field_required && required_addtionalfields.push({ name:item.field_name,required:item.field_required ,type:item.field_type  }))

    const { register , handleSubmit , getValues , setValue , watch , formState , control} = useForm({
        values:{
            work_mornings:props.work_mornings,
            work_evenings:props.work_evenings,
            work_afternoons:props.work_afternoons,
            work_occasional:props.work_occasional,
            work_parttime:props.work_parttime,
            work_fulltime:props.work_fulltime,
            work_nights:props.work_nights,
            work_weekends:props.work_weekends,
            work_anytime:props.work_anytime,
            availablestartdate:props.availablestartdate,
            shortnotice:props.shortnotice,
            reduceworkflexibility:props.reduceworkflexibility,
            workstate:props.workstate,
            addtionalFields:userFields
        },
        // resolver:yupResolver(general_availabilitySchema)
    }),
    { errors } = formState;
    const { fields } = useFieldArray({ name:"addtionalFields" ,control })

    const handleOnDateChange = (e ='' ,name='') => {
        let _date = isValidDate(e) ? moment(e): '';
        isValidDate(e) &&  setValue(name,_date)
    }

    const onFormSubmit = (data={}) =>{
        // if(!formState.isDirty){
        //     return toggleAccordion && toggleAccordion("id_right_to_work");
        // }
        let body = {...data }
        body.addtionalFields =  IsArray(data.addtionalFields) ? data.addtionalFields.map((item ={})=>({
            field_heading:item.field_heading.name ,
            field_menu:item.field_menu.name ,
            field_type:item.field_type, 
            value: (item.field_type ==="date") ? convertToISOString(item.value) : item.value, 
            _id:item._id 
        })) 
        : [];
        body.addtionalFields =  JSON.stringify(IsArray(body.addtionalFields)? body.addtionalFields : [])
        const personalData = ({...body ,setctionId:"general_availability"});
        if(updateForm){
            updateForm(personalData).then((res)=>{
                handleSetToast && handleSetToast("general_availability" , (res && res.response) ,"success")
                toggleAccordion && toggleAccordion("id_right_to_work");
            })
        }
    }



    return <Form onSubmit={handleSubmit(onFormSubmit )}>

        <MultipleCheckBox label='When are you able to work?' register={register} options={abletowork} toggleName={abletowork_name} />

        <DateInput parentClassName='col-md-6 earliest_date' handleOnDateChange={handleOnDateChange} name="availablestartdate" label="What is the Earliest Date you can start work" value={watch("availablestartdate")} error={errors.availablestartdate && errors.availablestartdate.message} />


        <YESORNO label="Would you be willing to work at short notice?" name="shortnotice" register={register} />


        <YESORNO label="Do you have any commitments that reduce your flexibility to work?" name="reduceworkflexibility" register={register} />


        <TextAreaInput label="Please provide details" parentClassName="col-md-12 prove_details mt-4"  placeholder="Please provide details"  {...register("workstate")} />

        {/* Addtional Fields for the section personal details  */}
        <AddtionalFormFields 
            fields={fields}  
            register={register} 
            handleOnDateChange={handleOnDateChange} 
            watch={watch} 
            errors={errors} 
            toggleImageViewer={toggleImageViewer}
            setValue={setValue}
            getValues={getValues}
        />

        <NextButton />

    </Form>
}


const IdOptions = ['Passport' ,"Driving Licence" ,"Identity Card" ,"Birth Certificate (UK Only)" ,"Certificate of Registration (UK Only)" ,"Travel Document (UK Only)"];
const workOptions = ['Visa' , "Work Permit","Residence Permit" ,"Permanent Residence Card" ,"Biometric Card" ,"Immigration Status Residence" , "Certificate of Naturalisation"]



const id_right_to_workSchema = yup.object().shape({

    docType:yup.string(),
    doc_url: yup.array(),
    doc_no:yup.string().when("docType",function(v ,sc,{}){
        return v[0] ?  sc.required("Required") : sc.notRequired()
    }),
    country_issue: yup.string().when("docType",function(v ,sc,{}){
        return v[0] ?  sc.required("Required") : sc.notRequired()
    }),
    expiry_date: yup.string(),
    isvisible:yup.boolean(),

    rightToWorkType:yup.string(),
    rightToWork_doc_url: yup.array(),
    rightToWork_doc_no: yup.string(),
    rightToWork_country_issue: yup.string(),
    rightToWork_expiry_date: yup.string(),
    // rightToWork_isvisible:yup.boolean(),

    // Right to work


});

const IDAndRightToWork = (props = initailState) => {


    const { toggleAccordion , handleSetToast , updateForm , active_accordion} = props ;

    const { register , handleSubmit , watch , getValues , setValue , formState:{errors} ,setError , reset} = useForm({
        resolver:yupResolver(id_right_to_workSchema),
        values:{
            docType:props.docType,
            doc_url:props.docType_info.doc_url,
            doc_no:props.docType_info.doc_no,
            country_issue:props.docType_info.country_issue,
            expiry_date:props.docType_info.expiry_date,
            isvisible:props.docType_info.isvisible,

            rightToWorkType:props.rightToWorkType,
            rightToWork_doc_url:props.rightToWorkType_info.doc_url,
            rightToWork_doc_no:props.rightToWorkType_info.doc_no,
            rightToWork_country_issue:props.rightToWorkType_info.country_issue,
            rightToWork_expiry_date:props.rightToWorkType_info.expiry_date,
            rightToWork_isvisible:props.rightToWorkType_info.isvisible,
            share_code: props.rightToWorkType_info.share_code
        }
    });

    const initialViewer = {
        viewUrl:"",
        isPreview:false
    }
    const [Viewer , setViewer]  = useState(initialViewer)
    const [uploadTooltip ,setUploadTooltip] = useState(false)


    // value on change listener....
    let upload_isdisable = watch(['country_issue' ,"doc_no" ] ,{ country_issue:"" , doc_no:""}).every(Boolean),
        righttowork_doc_isdisabled = watch(['rightToWork_country_issue' , 'rightToWork_doc_no'],{rightToWork_country_issue:"",rightToWork_doc_no:'' }).every(Boolean),
        _watch_docType =  watch("docType",''),
        _watch_country = watch("country_issue",''),
        _watch_doc_url = watch('doc_url',[]),
        _watch_rightToWork_doc_url = watch('rightToWork_doc_url',[]),
        _watch_rightToWorkType = watch('rightToWorkType',[]);


    useEffect(()=>{
        setUploadTooltip(upload_isdisable && !_watch_doc_url.length)
    },[upload_isdisable ,_watch_doc_url])


    // useEffect(()=>{
    //     if(!_watch_docType){
    //         reset({doc_no:'' , country_issue:""},{},)
    //     }
    // },[_watch_docType])
    


    const toggleImageViewer = (url = '') =>{
        url = String(url).startsWith('uploads/images') ? `${NodeURL}/${url}` : ''
        setViewer((prev)=>({...prev , viewUrl:url, isPreview:!prev.isPreview}))
    }

    const handleOnDateChange = (e ='' ,name='') => {
        let _date = isValidDate(e) ? moment(e): '';
        isValidDate(e) &&  setValue(name,_date , {shouldDirty:true})
    }

    const handleOnSelect = (e = {}, name = '') =>{
        let value =  (e && e.value)
        name && setValue(name ,value)
        if(_watch_docType && !value){
            setError(name,{message:"Required"})
        }else{
            setError(name,{message:""})
        }
    }



    // ["pdf" , "png" ,"jpeg" ,"jpg"].includes(temp1.type))slice('dddddimage/png'.search("/"))
    const handleIDFiles = async (e = {} ,type = '') =>{
        let files = (e && e.target && e.target.files) ? e.target.files : [];
            files = files.length ? files[0] : null;

        if(!files) return;
        if(!(files.size < 5242880)){
            return toast.error("Maximum upload size is 5MB");
        }
        if(!["pdf" , "png" ,"jpeg" ,"jpg"].includes(files.type.slice(files.type.search("/") + 1))){
            return toast.error("File Format not supported");
        }
            let data = createFormData({upload_doc : files})
            let url = await addfileToServer(data);
            if(url && (_watch_doc_url || _watch_rightToWorkType)){
                if(type === "rightToWork_doc_url"){
                    return setValue("rightToWork_doc_url" , [..._watch_rightToWork_doc_url , url])
                }
                setValue("doc_url" ,[..._watch_doc_url , url])
                // toast.success("File Saved!")
            }


    }

    const handleIDFilesDelete = (path ="" , type = "") => {
        let url;
        if(type === 'rightToWork_doc_url'){
            url = _watch_rightToWork_doc_url.filter(i => i !== path);
            return setValue(type , url)
        }

        // doc type is array
        if(!_watch_doc_url) return;
        url = _watch_doc_url.filter(i => i !== path);
        setValue("doc_url" , url);

    }


    const onFormSubmit = (data = {}) => {
        // if(!formState.isDirty){
        //     return toggleAccordion && toggleAccordion("driving_license_details");
        // }
        console.log(data,'data')
        if(data.docType && Array.isArray(data.doc_url) && !data.doc_url.length) return;
        let body = { ...data };
        body.docType_info_doc_type = body.docType || "";
        body.rightToWorkType_info_doc_type = body.rightToWorkType || "";
        const personalData = createFormData({ ...body, setctionId: "id_right_to_work" });
        if (updateForm) {
            updateForm(personalData).then((res) => {
                setUploadTooltip(false)
                handleSetToast && handleSetToast("formupdate", (res && res.response), "success")
                toggleAccordion && toggleAccordion("driving_license_details");

            })
        }
    }

    const toggleUploadTooltip =()=>{
        // setUploadTooltip()
    }

    return(
    <>
        <Form onSubmit={handleSubmit(onFormSubmit)}>
            <div className="position-relative col-12 col-md-12 mb-5">
                <p>
                    Provide details about your proof of right to work in the
                    UK.
                </p>
            </div>
            <SelectInput label="Identity Document" placeholder="Identity Document" options={IdOptions} lowercase={false}  {...register("docType")} />

            {
            _watch_docType &&
            <div className="position-relative col-12 col-md-12 d-flex flex-wrap p-0 three_col">

                <div className="position-relative col-12 col-md-3">
                    <div className="form-group select_box">
                        <Select
                            options={countries}
                            className={`select-box ${errors.country_issue && errors.country_issue.message ? "invalid-select-input" : ""}`}
                            classNamePrefix={"select-class"}
                            isClearable={true}
                            styles={customStyles}
                            value={countries.find(con => con.value === _watch_country)}
                            onChange={(e)=>handleOnSelect(e ,'country_issue')}
                            ref={register("country_issue").ref}
                        />
                        <label className={`${ errors.country_issue && errors.country_issue.message ? "invalid-select":""}`} >Country of Issue <RequiredTag required display="inline" /></label>
                    </div>
                </div>

                <TextInput label="Doc Number" required placeholder='Doc Number' parentClassName="col-md-3" error={errors.doc_no && errors.doc_no.message} {...register("doc_no")}/>

                {
                   _watch_docType !== 'Birth Certificate' &&
                    <DateInput label="Expiry Date" name="expiry_date" required handleOnDateChange={handleOnDateChange} value={watch("expiry_date")} parentClassName='col-md-3' />
                }

                <div className="position-relative col-12 col-md-3 file_join">
                    <div className="form-group doc-list">
                        <div className="edit-upload-file">
                            <label id="doc_file_upload">
                            <img  src={Upload} style={{cursor:'pointer'}} alt="" className={`${upload_isdisable ? "" : 'uploadfile-disabled'}`}  />
                                <input className="d-none" disabled={!upload_isdisable} type="file" accept="application/pdf,.pdf,image/*" onChange={handleIDFiles} />
                                <Tooltip placement='right' className="uploadTooltip" isOpen={active_accordion===5 && uploadTooltip} target="doc_file_upload" toggle={toggleUploadTooltip} >Please upload file</Tooltip>
                            </label>
                        </div>
                    </div>
                                
                </div>

                <div className="position-relative col-12 col-md-12">
                    <div className="form-group doc-list">
                        <ul>
                            {
                                IsArray(getValues("doc_url"))
                                ? _watch_doc_url.map((url = '')=>url.startsWith('uploads/images') ? <FileViewDoc key={url} url={url} onClick={()=>toggleImageViewer(url)} onDelete={()=>handleIDFilesDelete(url)} /> : null )
                                : <></>
                            }
                        </ul>
                    </div>
                </div>


            </div>
            }

            {/*  Right to Work<   */}
            {
            !["United Kingdom"].includes(_watch_country) || [IdOptions[1],IdOptions[2],IdOptions[5]].includes(_watch_docType)
            ?<>
            <SelectInput label="Proof of Right to Work" options={workOptions} lowercase={false} {...register("rightToWorkType")} />
            {!['Immigration Status Residence', 'Certificate of Naturalisation', ''].includes(_watch_rightToWorkType) ?   
            <TextInput label="Share Code"  placeholder='Share Code' parentClassName="col-md-3" error={errors.share_code && errors.share_code.message} {...register("share_code")}/> : null }


            <div className="position-relative w-100">
                <hr className="m-15" />
                {
                watch("rightToWorkType") &&
                <div className="d-flex flex-wrap three_col">

                    <h6 className="p-15 w-100" style={{ color: "#5f4b95" }}>
                        {getValues("rightToWorkType")}
                    </h6>

                <TextInput label="Doc Number/Ref" placeholder='Doc Number/Ref' parentClassName="col-md-3" {...register("rightToWork_doc_no")}/>

                <div className="position-relative col-12 col-md-3">
                    <div className="form-group select_box">
                        <Select
                            options={countries}
                            className={"select-box"}
                            classNamePrefix={"select-class"}
                            isClearable={true}
                            styles={customStyles}
                            value={countries.find(con => con.value === watch("rightToWork_country_issue"))}
                            onChange={(e)=>handleOnSelect(e ,'rightToWork_country_issue')}
                        />
                        <label>Country of Issue</label>
                    </div>
                </div>

                {
                <DateInput label="Doc Expiry Date" name="rightToWork_expiry_date" handleOnDateChange={handleOnDateChange} value={watch("rightToWork_expiry_date")} parentClassName='col-md-3' />
                }

                    <div className="position-relative col-12 col-md-3">


                    <div className="form-group edit_file_icon">
                        <div className="edit-upload-file">
                        <label>
                            <img src={Upload} style={{cursor:'pointer'}} alt="" className={`${righttowork_doc_isdisabled ? "" : 'uploadfile-disabled'}`}  />
                            <input className="d-none" disabled={!righttowork_doc_isdisabled} type="file" accept="application/pdf,.pdf,image/*" onChange={(e)=>handleIDFiles(e , "rightToWork_doc_url")} />
                        </label>
                        </div>
                    </div>
                  


                    </div>
                    <div className="position-relative col-12 col-md-12">
                        <div className="form-group doc-list">
                            <ul>
                                    <ul>
                                    {
                                        IsArray(_watch_rightToWork_doc_url)
                                        ? _watch_rightToWork_doc_url.map((url = '')=>url.startsWith('uploads/images') ? <FileViewDoc key={url} url={url} onClick={()=>toggleImageViewer(url)} onDelete={()=>handleIDFilesDelete(url,"rightToWork_doc_url")} /> : null )
                                        : <></>
                                    }
                                </ul>
                            </ul>
                        </div>
                    </div>
                </div>
                }
            </div>      
            </>
            : null

            }



            <NextButton />
        </Form>
        <ImageViewModel filepath={Viewer.viewUrl} isOpen={Viewer.isPreview} toggle={toggleImageViewer} />
    </>
    )

}






const drivinglicensedetailsSchema = yup.object({
	// drivinglicenceisVisible:true,
    drivinglicence:yup.string(),
    drivinglicenceno:yup.string().when("drivinglicence",function(v ,sc,{}){
        return (v[0]=='yes') ?  sc.required("Required") : sc.notRequired()
    }),
    licenceExpiry:yup.string().when("drivinglicence",function(v ,sc,{}){
        return (v[0]=='yes') ?  sc.required("Required") : sc.notRequired()
    }),
    licenceClass:yup.string().when("drivinglicence",function(v ,sc,{}){
        return (v[0]=='yes') ?  sc.required("Required") : sc.notRequired()
    }),
    caraccess:yup.string(),
    bannedfromdriving:yup.string(),
	drivingCountryOfIssue:yup.string().when("drivinglicence",function(v ,sc,{}){
        return (v[0]=='yes') ?  sc.required("Required") : sc.notRequired()
    }),
    uploaddriving:yup.array().when("drivinglicence",function(v ,sc,{}){
        return v[0] ==='yes' ?  sc.min(1).required("Please upload file") : sc.notRequired();
    })

})

const DrivingLicenseDetails = (props = initailState) => {

	const { toggleAccordion , handleSetToast , updateForm,active_accordion, toggleImageViewer=()=>{}  } = props ;

    const [uploadTooltip ,setUploadTooltip] = useState(false)
	const {register , handleSubmit , setValue , formState:{errors,} , watch ,setError , reset} = useForm({
		values:{
			bannedfromdriving:props.bannedfromdriving,
			// drivinglicenceisVisible:props.drivinglicenceisVisible,
			drivinglicence:props.drivinglicence,
			drivinglicenceno:props.drivinglicenceno,
			drivingCountryOfIssue:props.drivingCountryOfIssue,
			licenceExpiry:props.licenceExpiry,
			licenceClass:props.licenceClass,
			caraccess:props.caraccess,
            uploaddriving:props.uploaddriving
		},
		resolver:yupResolver(drivinglicensedetailsSchema)
	});
    const _watch_drivinglicence = (watch("drivinglicence",'') === "yes")
    
    let _watch_drivingFiles = watch("uploaddriving",[])


    useEffect(()=>{
        if(!_watch_drivinglicence){
            reset((fv)=>({...fv ,licenceClass:"" , drivinglicenceno:"" , licenceExpiry:"" ,drivingCountryOfIssue:""}),{},)
        }
    },[_watch_drivinglicence])

    useEffect(()=>{
        setUploadTooltip(Boolean(active_accordion===6 && errors.uploaddriving && errors.uploaddriving.message && _watch_drivinglicence && !_watch_drivingFiles.length))
    },[errors,_watch_drivinglicence,_watch_drivingFiles ,active_accordion])

    const handleOnSelect = (e , name = '') =>{
        let value = (e && e.value) || ""
        name && setValue(name ,value ,{shouldDirty:true})
        if(_watch_drivinglicence && !value){
            setError(name,{message:"Required"})
        }else{
            setError(name,{message:""})
        }
    }

	const handleOnDateChange = (e ='' ,name='') => {
        let _date = isValidDate(e) ? moment(e): '';
        isValidDate(e) &&  setValue(name,_date)
    }
    // ["pdf" , "png" ,"jpeg" ,"jpg"].includes(temp1.type))slice('dddddimage/png'.search("/"))
    const handleFiles = async (e = {} ,type = '') =>{
        let files = (e && e.target && e.target.files) ? e.target.files : [];
            files = files.length ? files[0] : null;

        if(!files) return;
        if(!(files.size < 5242880)){
            return toast.error("Maximum upload size is 5MB");
        }
        if(!["pdf" , "png" ,"jpeg" ,"jpg"].includes(files.type.slice(files.type.search("/") + 1))){
            return toast.error("File Format not supported");
        }
            // console.log(files, '_watch_drivingFiles')
            let data = createFormData({upload_doc : files})
            let url = await addfileToServer(data);
            if(url && _watch_drivingFiles){
                setValue("uploaddriving" ,[..._watch_drivingFiles , { name:files.name,path:url }],{shouldDirty:true})
                // toast.success("File Saved!")
            }


    }
    const handleFilesDelete = (path ="" , type = "") => {
        let uploaddrivingnew = _watch_drivingFiles.filter(i => i.path !== path);
        setValue("uploaddriving" , uploaddrivingnew);

    }


	const onFormSubmit = (data) =>{
        // if(!formState.isDirty){
        //     return toggleAccordion && toggleAccordion("language_details");
        // }
        let uploaddriving = JSON.stringify(IsArray(data.uploaddriving) ? data.uploaddriving : []);
        const personalData = createFormData({...data ,uploaddriving,setctionId:"driving_license_details"});
        if(updateForm){
            updateForm(personalData).then((res)=>{
                handleSetToast && handleSetToast("formupdate" , (res && res.response) ,"success")
		        toggleAccordion && toggleAccordion("language_details");
                
            })
        }
    }

	return <Form onSubmit={handleSubmit(onFormSubmit)}>
		<div className="position-relative w-100">
			{/* <hr className="m-15"/> */}
			<div className="d-flex flex-wrap">

				<YESORNO label="Do you have a driving License?" name="drivinglicence" register={register} />
				{
				_watch_drivinglicence &&
				<>
				<TextInput label="License Number" required={_watch_drivinglicence} error={errors.drivinglicenceno && errors.drivinglicenceno.message}  placeholder="License Number" {...register("drivinglicenceno")}/>

				{/* React select input  */}
				<div className="position-relative col-12 col-md-4">
					<div className="form-group select_box">
							<Select
								options={countries}
								className={`select-box ${errors.drivingCountryOfIssue && errors.drivingCountryOfIssue.message ? "invalid-select-input" : ""}`}
								classNamePrefix={"select-class"}
								styles={customStyles}
								isClearable={true}
								onChange={(e)=>handleOnSelect(e , "drivingCountryOfIssue")}
								value={countries.find(i=>i.value=== watch("drivingCountryOfIssue"))}
                                // innerRef={}
							/>
						<label className={`${ errors.drivingCountryOfIssue && errors.drivingCountryOfIssue.message ? "invalid-select":""}`} >Country of Issue <RequiredTag required={_watch_drivinglicence} display="inline"/> </label>
					</div>
				</div>

                <DateInput label="License Expiry Date" name="licenceExpiry" required={_watch_drivinglicence} error={errors.licenceExpiry && errors.licenceExpiry.message}  handleOnDateChange={handleOnDateChange} value={watch("licenceExpiry")} />

				<TextInput label="License Class" placeholder="License Class"  required={_watch_drivinglicence} {...register("licenceClass")} error={errors.licenceClass && errors.licenceClass.message}  />

                <div className="position-relative col-3 col-md-1 file_join">
                        <div className="form-group doc-list">
                            <div className="edit-upload-file">
                                <label id="driving_license_file_upload">
                                <img  src={Upload} style={{cursor:'pointer'}} alt="" /* className={`${upload_isdisable ? "" : 'uploadfile-disabled'}`}  */ />
                                    <input className="d-none" /* disabled={!upload_isdisable} */ type="file" accept="application/pdf,.pdf,image/*" onChange={handleFiles} />
                                    <Tooltip placement='right' className="uploadTooltip driving_license_uploadTooltip" isOpen={uploadTooltip} target="driving_license_file_upload" toggle={()=>{}} >Please upload file</Tooltip>
                                </label>
                            </div>
                        </div>                                
                </div>

                <div className="position-relative col-2 col-md">
                    <div className="form-group doc-list">
                        <ul>
                            {
                                IsArray(_watch_drivingFiles)
                                ? _watch_drivingFiles.map((item = {})=>item.path.startsWith('uploads/images') ? <FileViewDoc key={item.path} url={item.path} onClick={()=>toggleImageViewer(item.path)} onDelete={()=>handleFilesDelete(item.path)} /> : null )
                                : <></>
                            }
                        </ul>
                    </div>
                </div>
				</>
				}
				<YESORNO label="Do you have access to a car that you can use for work?" name="caraccess" register={register} />

				<YESORNO label="Have you been banned from driving. or do you have any current endorsements on you License?" name="bannedfromdriving" register={register} />
			</div>
		</div>
		<NextButton />
	</Form>
}





const language_detailsSchema = yup.object({
	englishspoken:yup.string(),
    englishwritten:yup.string(),
    otherlanguage:yup.array(),
    IELTStest:yup.string(),
})

const engOptions = ['Fluent' , "Good" ,"Fair"];


const LanguageDetails = (props = initailState) => {


	const { toggleAccordion , handleSetToast , updateForm} = props ;

	const {register , handleSubmit , setValue , formState , watch} = useForm({
		values:{
			englishspoken:props.englishspoken,
			englishwritten:props.englishwritten,
			otherlanguage:props.otherlanguage,
			IELTStest:props.IELTStest,
		},
		resolver:yupResolver(language_detailsSchema)
	})


	// for multi select
	const handleOnSelect = (e , name = '') =>{
        // let value = (e && e.value) || ""
        name && setValue(name ,e)
    }

	const onFormSubmit = (data) =>{
        // if(!formState.isDirty){
        //     return toggleAccordion && toggleAccordion("dbsdetails");
        // }
        let otherlanguage = JSON.stringify(IsArray(data.otherlanguage) ? data.otherlanguage : []);
        const personalData = createFormData({...data,otherlanguage ,setctionId:"language_details"});
        if(updateForm){
            updateForm(personalData).then((res)=>{
                handleSetToast && handleSetToast("formupdate" , (res && res.response) ,"success")
                toggleAccordion && toggleAccordion("dbsdetails");
            })
        }
    }





	return <Form onSubmit={handleSubmit(onFormSubmit)}>

		<MultipleChoice label="English - Spoken" options={engOptions} register={register}  name="englishspoken" />

		<MultipleChoice label="English - Written" options={engOptions}  register={register} name="englishwritten"/>

		<div className="position-relative col-12 col-md-4 mt-3">
            <div className="form-group select_box">
                <Select
                    options={languages}
                    className={"select-box"}
                    classNamePrefix={"select-class"}
                    styles={customStyles}
                    value={watch("otherlanguage")}
                    onChange={(e)=>handleOnSelect(e ,'otherlanguage')}
                    isMulti
                />
                <label>Other Languages Spoken</label>
            </div>
        </div>

		{
		watch(["englishspoken",'englishwritten']).includes("fair")
		? <>
		<YESORNO label="Have you passed each of the academic modules of the IELTS test?" name="IELTStest" register={register} />
		{
		watch("IELTStest") === 'yes' &&
			<div className="col-12 col-md-12"><p className="pl-note"><strong> Please note:</strong> you have to provide copies of all IELTS certificates held by you</p></div>
		}
		</>
		: <></>
		}

		<NextButton />


	</Form>
}






const dbsdetailsSchema = yup.object({
	currentDBS:yup.string(),
    dbsCertificateNo:yup.string().when("currentDBS",function(v ,sc,{}){
        return v[0] ==='yes' ?  sc.required("Required") : sc.notRequired()
    }),
    dbsIssueDate:yup.string().when("currentDBS",function(v ,sc,{}){
        return v[0] ==='yes' ?  sc.required("Required") : sc.notRequired()
    }),
    dbsExpirydate:yup.string().when("currentDBS",function(v ,sc,{}){
        return v[0] ==='yes' ?  sc.required("Required") : sc.notRequired()
    }),
    uploaddbs:yup.array().when("currentDBS",function(v ,sc,{}){
        return v[0] ==='yes' ?  sc.min(1).required("Please upload file") : sc.notRequired();
    })
    
})

const DBSDetails = (props = initailState) => {

	const { toggleAccordion , handleSetToast , updateForm, toggleImageViewer,active_accordion } = props ;

    const [uploadTooltip ,setUploadTooltip] = useState(false)
	const {register , handleSubmit , setValue , getValues , watch, formState:{ errors }} = useForm({
		values:{
			currentDBS:props.currentDBS,
			dbsCertificateNo:props.dbsCertificateNo,
			dbsIssueDate:props.dbsIssueDate,
			dbsExpirydate:props.dbsExpirydate,
            uploaddbs:props.uploaddbs || []
		},
		resolver:yupResolver(dbsdetailsSchema)
	})
    // value on change listener....
    let _watch_dbsFiles = watch("uploaddbs",[])
    let _watch_currentDBS = watch("currentDBS",'') === 'yes';



    useEffect(()=>{
        setUploadTooltip(Boolean(active_accordion===8 && errors.uploaddbs && errors.uploaddbs.message && _watch_currentDBS && !_watch_dbsFiles.length))
    },[errors,_watch_currentDBS,_watch_dbsFiles ,active_accordion])


	const handleOnDateChange = (e ='' ,name='') => {
        let _date = isValidDate(e) ? moment(e): '';
        isValidDate(e) &&  setValue(name,_date)
    }

    // ["pdf" , "png" ,"jpeg" ,"jpg"].includes(temp1.type))slice('dddddimage/png'.search("/"))
    const handleDBSFiles = async (e = {} ,type = '') =>{
        let files = (e && e.target && e.target.files) ? e.target.files : [];
            files = files.length ? files[0] : null;

        if(!files) return;
        if(!(files.size < 5242880)){
            return toast.error("Maximum upload size is 5MB");
        }
        if(!["pdf" , "png" ,"jpeg" ,"jpg"].includes(files.type.slice(files.type.search("/") + 1))){
            return toast.error("File Format not supported");
        }
            console.log(files, '_watch_dbsFiles')
            let data = createFormData({upload_doc : files})
            let url = await addfileToServer(data);
            if(url && _watch_dbsFiles){
                setValue("uploaddbs" ,[..._watch_dbsFiles , { name:files.name,path:url }],{shouldDirty:true})
                // toast.success("File Saved!")
            }


    }
    const handleDBSFilesDelete = (path ="" , type = "") => {
        let uploaddbsnew = _watch_dbsFiles.filter(i => i.path !== path);
        setValue("uploaddbs" , uploaddbsnew);

    }


    const onFormSubmit = async (data = {}) => {
        // if(!formState.isDirty){
        //     return toggleAccordion && toggleAccordion("nextofcontact");
        // }
        let uploaddbs = JSON.stringify(IsArray(data.uploaddbs) ? data.uploaddbs : []);
        const dbsdetails = createFormData({ ...data,uploaddbs, setctionId: "dbsdetails" });
        if (updateForm) {
            updateForm(dbsdetails).then((res) => {
                handleSetToast && handleSetToast("formupdate", (res && res.response), "success")
                toggleAccordion && toggleAccordion("nextofcontact");

            })
        }
    }



	return <Form onSubmit={handleSubmit(onFormSubmit)}>
		<div className="position-relative w-100">
			<div className="d-flex flex-wrap">


				<YESORNO label="Do you have a current DBS" name="currentDBS" register={register} />

				{
				_watch_currentDBS
				?<>
					<TextInput required={_watch_currentDBS} error={errors.dbsCertificateNo && errors.dbsCertificateNo.message } label="Certificate No" placeholder="Certificate No" {...register("dbsCertificateNo")} />


					<DateInput required={_watch_currentDBS} label="Issue Date" name="dbsIssueDate" handleOnDateChange={handleOnDateChange} value={watch("dbsIssueDate")} />


					<DateInput required={_watch_currentDBS} label="Expiry Date" name="dbsExpirydate" handleOnDateChange={handleOnDateChange} value={watch("dbsExpirydate")}/>
                    {/* <UploadInput id='dfdsfds' label='fdsfdsfds'  /> */}

                    <div className="position-relative col-3 col-md-1 file_join">
                        <div className="form-group doc-list">
                            <div className="edit-upload-file">
                                <label id="dbs_file_upload">
                                <img  src={Upload} style={{cursor:'pointer'}} alt="" /* className={`${upload_isdisable ? "" : 'uploadfile-disabled'}`}  */ />
                                    <input className="d-none" /* disabled={!upload_isdisable} */ type="file" accept="application/pdf,.pdf,image/*" onChange={handleDBSFiles} />
                                    <Tooltip placement='right' className="uploadTooltip" isOpen={uploadTooltip} target="dbs_file_upload" toggle={()=>{}} >Please upload file</Tooltip>
                                </label>
                            </div>
                        </div>                                
                    </div>

                    <div className="position-relative col-2 col-md">
                        <div className="form-group doc-list">
                            <ul>
                                {
                                    IsArray(_watch_dbsFiles)
                                    ? _watch_dbsFiles.map((item = {})=>item.path.startsWith('uploads/images') ? <FileViewDoc key={item.path} url={item.path} onClick={()=>toggleImageViewer(item.path)} onDelete={()=>handleDBSFilesDelete(item.path)} /> : null )
                                    : <></>
                                }
                            </ul>
                        </div>
                    </div>
				</>
				: <></>

				}
			</div>
		</div>

		<NextButton />

	</Form>
}







const nextofcontactSchema = yup.object({
    kinfirstname:yup.string(),
    kinlastname:yup.string(),
    kinrelationship:yup.string(),
    kinhomephone:yup.string().min(10 ,"Incorrect Mobile No"),
	kin_dailcountry:yup.string(),
	kin_number:yup.string().min(10 ,"Incorrect Mobile No"),
	kin_code:yup.string(),
    kinemail:yup.string().email("Incorrect Email"),
    save_as_my_current:yup.bool(),
    kinstreetAddress:yup.string(),
    kinaddressline2:yup.string(),
    kincity:yup.string(),
    kinstate:yup.string(),
    kinzip:yup.string(),
    kincountry:yup.string()

});



const NextOfKin = (props = initailState) => {

	const { toggleAccordion , handleSetToast , updateForm ,toggleTab } = props ;

	const {register , handleSubmit , setValue , getValues , watch , formState , reset ,} = useForm({
		values:{
			kinfirstname:props.kinfirstname ,
			kinlastname:props.kinlastname ,
			kinrelationship:props.kinrelationship ,
			kinhomephone:props.kinhomephone ,
			kin_dailcountry:props.kinmobileno.dailcountry || "",
			kin_number:props.kinmobileno.number || "",
			kin_code:props.kinmobileno.code || "",
			kinemail:props.kinemail ,

			// Address for kin/EC
			save_as_my_current:props.save_as_my_current,
			kinstreetAddress:props.kinstreetAddress ,
			kinaddressline2:props.kinaddressline2 ,
			kincity:props.kincity ,
			kinstate:props.kinstate ,
			kinzip:props.kinzip,
			kincountry:props.kincountry

		},
		resolver:yupResolver(nextofcontactSchema)
	}),
	{ errors } = formState;
    const kinstreetAddress = register("kinstreetAddress");

	// let watchSave_current_address = watch("save_as_my_current",false)

	// streetAddress:"", from the contact address
    // addressline2:"",
    // city:"",
    // state:"",
    // zip:"",
    // country:"",
	const setCurrentAddress = (ref_address) =>{
		setValue("kinstreetAddress" , ref_address ? props.streetAddress : "" , { shouldDirty:true })
		setValue("kinaddressline2" , ref_address ? props.addressline2 : "",{ shouldDirty:true })
		setValue("kincity" , ref_address ? props.city : "", { shouldDirty:true })
		setValue("kinstate" , ref_address ? props.state : "" , { shouldDirty:true })
		setValue("kinzip" , ref_address ? props.zip : "" , { shouldDirty:true })
		setValue("kincountry" , ref_address ? props.country : "" , { shouldDirty:true })
	}

    const onFormSubmit = async (data={}) => {
		const nextofcontact = createFormData({...data ,setctionId:"nextofcontact" });
        if(updateForm){
            updateForm(nextofcontact).then((res)=>{
                handleSetToast && handleSetToast("nextofcontact" , (res && res.response) ,"success")
                reset({} ,{ keepDirty:false , keepValues:true })
            })
        }
    }

	const handleOnContinue = async () =>{
        if(formState.isDirty){
            onFormSubmit(getValues())
        }
        toggleTab("submenu" , "2")
	}

    const handleOnAddressSelect = (data = {} , res)=>{
        const {  addressline1 = "" ,addressline2 = "" ,city = "" ,state = "" ,country = "" ,zip  = "" } = data;
         setValue("kinstreetAddress" , addressline1 , {shouldDirty:true});
         setValue("kinaddressline2" , addressline2 , {shouldDirty:true});
         setValue("kincity" , city , {shouldDirty:true});
         setValue("kinstate" , state , {shouldDirty:true});
         setValue("kincountry" , country , {shouldDirty:true});
         setValue("kinzip" , zip , {shouldDirty:true});


    }


	return <Form onSubmit={handleSubmit(onFormSubmit)}>

		<TextInput label="First Name" placeholder="First Name" {...register("kinfirstname")} />

		<TextInput label="Last Name" placeholder="Last Name" {...register("kinlastname")} />

		<TextInput label="Relationship to you" placeholder="Relationship to you" {...register("kinrelationship")} />

		<NumberInput label="Home/Work Phone" error={errors.kinhomephone && errors.kinhomephone.message} placeholder="Home/Work Phone" {...register("kinhomephone")} />

		<NumberInput label="Mobile No" placeholder="Mobile No" error={errors.kin_number && errors.kin_number.message} {...register("kin_number")} />

		<TextInput label="Email Address" error={errors.kinemail && errors.kinemail.message} placeholder="Email Address" {...register("kinemail")} />


		<div className="position-relative col-12 col-md-12 mb-4">
			<p>
				<strong>Address</strong>
			</p>
		</div>

		<div className="position-relative col-12 col-md-4">
			<div className="form-check-box one_radio">
				<span>
					<input type="checkbox"
					onChange={(e)=>{
						setValue("save_as_my_current" ,e.target.checked);
						setCurrentAddress(e.target.checked)
					}}
					checked={watch("save_as_my_current")}
					/>
				</span>
				<p>Same as my current address</p>
			</div>
		</div>

		{/* <TextInput label="Street Address" placeholder="Street Address" {...register("kinstreetAddress")} /> */}

        <LocationSearchInput onSelect={handleOnAddressSelect} label="House/Flat/Building" ref={kinstreetAddress.ref} handleOnchange={(e)=>setValue("kinstreetAddress" ,e)} value={watch("kinstreetAddress")} />



		<TextInput label="Address Line 2" placeholder="Address Line 2" {...register("kinaddressline2")} />

		<TextInput label="City" placeholder="City" {...register("kincity")} />

		<TextInput label="State / Region" placeholder="State / Region" {...register("kinstate")} />

		<TextInput label="ZIP / Postal Code" placeholder="ZIP / Postal Code" {...register("kinzip")} />

		<TextInput label="Country" placeholder="Country" {...register("kincountry")} />

		{/* <NextButton /> */}
		<div className="position-relative col-12 col-md-12">
			<div className="text-center" id="s-c-buttons">
				<Button type="submit" className={`btn-save ${formState.isDirty ? "" : "cursor-no-drop"}`} disabled={!formState.isDirty} >Save</Button>
				<Button type="button" onClick={handleOnContinue}>Continue</Button>
			</div>
		</div>
	</Form>
}


// Employment & Education    tab 2


const Qualifications = (props = initailState) => {


    const { toggleAccordion , handleSetToast , updateForm ,toggleTab } = props ;

	const intialQualification = {
		// "_id": "",
		"qualification_course": "",
		"qualification_level": "",
		"qualification_title": "",
		"qualification_date": "",
		"fileName": "",
		"filePath": "",
		"qualification_date_expiry": ""
	};
	const { control, register , getValues , watch , handleSubmit ,setValue, formState , reset} = useForm({
		values:{
			education_qualification: props.education_qualification
		}
	});
	const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
	  control, // control props comes from useForm (optional: if you are using FormContext)
	  name: "education_qualification", // unique name for your Field Array

	});


    const initialViewer = {
        viewUrl:"",
        isPreview:false
    }
    const [Viewer , setViewer]  = useState(initialViewer)

    // To delete Qdoc
    const removeQdoc = async (id ='')=>{
        try {
            const res = await request({ url:"/candidate/form/deleteEducationData",method:"post" ,data:{ "edu_id": id}})
                return res.status;
        } catch (error) {
            return 0
        }
    }

    const toggleImageViewer = (url = '') =>{
        url = String(url).startsWith('uploads/images') ? `${NodeURL}/${url}` : ''
        setViewer((prev)=>({...prev , viewUrl:url, isPreview:!prev.isPreview}))
    }



	const handleOnDateChange = (e ='' ,name='') => {
        let _date = isValidDate(e) ? moment(e): '';
        isValidDate(e) &&  setValue(name,_date ,{shouldDirty:true})
    }

        // ["pdf" , "png" ,"jpeg" ,"jpg"].includes(temp1.type))slice('dddddimage/png'.search("/"))
    const handleOnFilesChange = async (e = {} ,name = '') =>{
        let files = (e && e.target && e.target.files) ? e.target.files : [];
            files = files.length ? files[0] : null;

        if(!files) return;
        if(!(files.size < 5242880)){
            return toast.error("Maximum upload size is 5MB");
        }
        if(!["pdf" , "png" ,"jpeg" ,"jpg"].includes(files.type.slice(files.type.search("/") + 1))){
            return toast.error("File Format not supported");
        }
            let data = createFormData({upload_doc : files})
            let url = await addfileToServer(data);

            url && setValue(`${name}.fileName` ,files.name );
            url && setValue(`${name}.filePath` , url);
            toast.success("File Uploaded" , {autoClose:2000})

    }

    const handleOnRemove = (index , Qdoc = {}) =>{
        // remove(index);
        if(Qdoc._id){
            removeQdoc(Qdoc._id).then((status)=>{
                if(status === 1){
                    remove(index);
                    handleSetToast("formupdate" , "Removed!" ,"success")                  
                }
            })
        }else{
            remove(index)
        }
    }

    const handleOnDeleteFile = (name = '' ) =>{
        setValue(name ,'');
        toast.success("File Removed" , {autoClose:2000})
    }
    

    const onFormSubmit = (data = {})=>{
        if(!formState.isDirty){
            return toggleAccordion && toggleAccordion("training_other_courses","employment_education")
        }
        let education_qualification = IsArray(data.education_qualification) 
        ? data.education_qualification.map((item)=>{
            item.qualification_date_expiry = item.renewal ?  item.qualification_date_expiry : '';
            return item;
        }).filter((item)=>Boolean( item.qualification_course && item.qualification_level)) : [];
            education_qualification = JSON.stringify(IsArray(education_qualification) ? education_qualification : []);
            

        if(updateForm){
            updateForm({education_qualification , setctionId:"education_qualification"}).then((res={})=>{
                reset({ },{ keepDirty:false , keepValues:true })
                if(res.result && res.result.education_qualification && IsArray(res.result.education_qualification)){
                    let education_qualification = res.result.education_qualification.map((item ={})=>{
                        item.renewal = Boolean(item.qualification_date_expiry);
                        return item;
                    })
                    setValue('education_qualification' ,education_qualification)
                }
                handleSetToast && handleSetToast("formupdate" , "saved!" ,"success")
                toggleAccordion && toggleAccordion("training_other_courses","employment_education")
            })
        }
    }



	return (
        <>
            <Form onSubmit={handleSubmit(onFormSubmit)}>
                <div className="emp_edu">
                        <p className="p-3 title_sub">
                            Please add and upload certificates of your qualifications.
                        </p>
                        {
                            IsArray(getValues("education_qualification")) &&  getValues("education_qualification").length > 0
                            ? <div className="position-relative col-12 col-md-12">
                                <div className="new-table hiding-calendar">
                                    <table className="table">
                                        <tr>
                                            <th>Course</th>
                                            <th>Level </th>
                                            <th>Title </th>
                                            <th>Date of Qualification </th>
                                            <th>Renewal (Tick if Yes)</th>
                                            <th>Upload</th>
                                            <th></th>
                                        </tr>
                                        {
                                            fields.map((Qdoc, index) => {
                                                return <tr key={Qdoc.id}>
                                                    <td>
                                                        <div className="form-group">
                                                            <input
                                                                type="text"
                                                                placeholder="Nursing"
                                                                className="form-control"
                                                                {...register(`education_qualification.${index}.qualification_course`)}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="form-group">
                                                            <input
                                                                type="text"
                                                                placeholder="Degree"
                                                                className="form-control"
                                                                {...register(`education_qualification.${index}.qualification_level`)}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="form-group">
                                                            <input
                                                                type="text"
                                                                placeholder="BA Hons"
                                                                className="form-control"
                                                                {...register(`education_qualification.${index}.qualification_title`)}

                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <DateInput 
                                                        parentClassName="mw-100 col-md" 
                                                        handleOnDateChange={(e)=>handleOnDateChange(e , `education_qualification.${index}.qualification_date`)} 
                                                        name={`education_qualification.${index}.qualification_date`} 
                                                        value={watch(`education_qualification.${index}.qualification_date`)} />
                                                    </td>
                                                    <td>
                                                        <div className="renewal_sec">
                                                            <div className="col-lg-1 form-group">
                                                                <input type="checkbox" {...register(`education_qualification.${index}.renewal` ,{value:Boolean(getValues(`education_qualification.${index}.qualification_date_expiry`))}) } />
                                                            </div>
                                                            {
                                                                watch(`education_qualification.${index}.renewal`) &&
                                                                <DateInput
                                                                    parentClassName="mw-100 col-md-12"
                                                                    handleOnDateChange={(e)=>handleOnDateChange(e , `education_qualification.${index}.qualification_date_expiry`)}
                                                                    name={`education_qualification.${index}.qualification_date_expiry`}
                                                                    value={watch(`education_qualification.${index}.qualification_date_expiry`)}
                                                                />

                                                            }

                                                        </div>
                                                    </td>
                                                    <td>
                                                        {
                                                            !Boolean(watch(`education_qualification.${index}.filePath`))
                                                            ? <div className="up_img">
                                                                <label>
                                                                    <img src={Upload} style={{ cursor: 'pointer' }} alt="" className={`${"upload_isdisable" ? "" : 'uploadfile-disabled'}`} />
                                                                    <input className="d-none" /* disabled={!upload_isdisable}*/ type="file" accept="application/pdf,.pdf,image/*" onChange={(e)=>handleOnFilesChange(e,`education_qualification.${index}` )} />
                                                                </label>
                                                            </div>
                                                            : <FileViewEmployment url={getValues(`education_qualification.${index}.filePath`)} onClick={(url)=>toggleImageViewer(url)} onDelete={(url)=>handleOnDeleteFile(`education_qualification.${index}.filePath` , url)} />
                                                        }
                                                    </td>
                                                    <td>
                                                        <Button type="button" onClick={(e) =>handleOnRemove(index , Qdoc)} className="table-close">x</Button>
                                                    </td>
                                                    </tr>
                                            })
                                        }
                                    </table>
                                </div>
                            </div>
                            : <></>
                        }
                        <div className="position-relative col-12 col-md-12">
                            <Button className="add-row" onClick={()=>append(intialQualification)}>+</Button>
                        </div>

                        <NextButton/>
	            </div>
            </Form>
            <ImageViewModel filepath={Viewer.viewUrl} isOpen={Viewer.isPreview} toggle={toggleImageViewer} />
        </>
    )
}


const TraningAndCourse = (props = initailState) => {

    const { toggleAccordion , handleSetToast , updateForm ,toggleTab } = props ;

	const intialTarining = {
        // "_id":"",
        "other_qualification_course": "",
        "other_qualification_level": "",
        "other_qualification_title": "",
        "other_qualification_date": "",
        "other_qualification_date_expiry": "",
        "fileName": "",
        "filePath": ""	
    };

	const { control, register , getValues , watch , handleSubmit ,setValue , formState , reset} = useForm({
		values:{
			training_other_courses: props.training_other_courses
		}
	});

	const { fields, append, remove } = useFieldArray({
	  control, // control props comes from useForm (optional: if you are using FormContext)
	  name: "training_other_courses", // unique name for your Field Array

	});


    const initialViewer = {
        viewUrl:"",
        isPreview:false
    }

    const [Viewer , setViewer]  = useState(initialViewer)



    // To delete Qdoc
    const removetrainingdoc = async (id ='')=>{
        try {
            const res = await request({ url:"/candidate/form/deleteOtherEducationData",method:"post" ,data:{ "othr_edu_id": id}})
                return res.status;
        } catch (error) {
            return 0
        }
    }

    const toggleImageViewer = (url = '') =>{
        url = String(url).startsWith('uploads/images') ? `${NodeURL}/${url}` : ''
        setViewer((prev)=>({...prev , viewUrl:url, isPreview:!prev.isPreview}))
    }



	const handleOnDateChange = (e ='' ,name='') => {
        let _date = isValidDate(e) ? moment(e): '';
        isValidDate(e) &&  setValue(name,_date , {shouldDirty:true})
    }

        // ["pdf" , "png" ,"jpeg" ,"jpg"].includes(temp1.type))slice('dddddimage/png'.search("/"))
    const handleOnFilesChange = async (e = {} ,name = '') =>{
        let files = (e && e.target && e.target.files) ? e.target.files : [];
            files = files.length ? files[0] : null;

        if(!files) return;
        if(!(files.size < 5242880)){
            return toast.error("Maximum upload size is 5MB");
        }
        if(!["pdf" , "png" ,"jpeg" ,"jpg"].includes(files.type.slice(files.type.search("/") + 1))){
            return toast.error("File Format not supported");
        }
            let data = createFormData({upload_doc : files})
            let url = await addfileToServer(data);

            url && setValue(`${name}.fileName` ,files.name );
            url && setValue(`${name}.filePath` , url);
            toast.success("File Uploaded" , {autoClose:2000})

    }

    const handleOnRemove = (index , trainingdoc = {}) =>{
        // remove(index);
        if(trainingdoc._id){
            removetrainingdoc(trainingdoc._id).then((status)=>{
                if(status === 1){
                    remove(index);
                    handleSetToast("formupdate" , "Removed!" ,"success")                  
                }
            })
        }else{
            remove(index)
        }
    }

    const handleOnDeleteFile = (name = '' ) =>{
        setValue(name ,'');
        toast.success("File Removed" , {autoClose:2000})
    }
    

    const onFormSubmit = (data = {})=>{
        if(!formState.isDirty){
            return toggleAccordion && toggleAccordion("professional_body_memberships","employment_education")
        }
        // other_courses
        let other_courses = IsArray(data.training_other_courses) 
                            ? data.training_other_courses.map((item)=>({...item,other_qualification_date_expiry: item.renewal ? item.other_qualification_date_expiry : "" })) 
                            : [];

            other_courses = JSON.stringify(IsArray(data.training_other_courses) ? data.training_other_courses : []);
        if(updateForm){
            reset({  },{ keepDirty:false , keepValues:true})
            updateForm({other_courses , setctionId:"training_other_courses"}).then((res)=>{
                if(res.result && res.result.other_courses && IsArray(res.result.other_courses)){
                    let training_other_courses = res.result.other_courses.map((item)=>{
                        item.renewal = Boolean(item.other_qualification_date_expiry);
                        return item
                    })
                    setValue('training_other_courses' ,training_other_courses ,{shouldDirty:false})
                }
                handleSetToast && handleSetToast("formupdate" , "saved!" ,"success")
                toggleAccordion && toggleAccordion("professional_body_memberships","employment_education")
            })
        }
    }

    return (
        <>
            <Form onSubmit={handleSubmit(onFormSubmit)}>
                <div className="emp_edu">
                    <p className="p-3 title_sub">
                        Please add all the mandatory training that you have
                        completed within the last 12 months You will be required to
                        provide copies of your training certificates
                    </p>

                    {
                        getValues("training_other_courses").length > 0
                        ?<div className="position-relative col-12 col-md-12">
                            <div className="new-table hiding-calendar">
                                <table className="table">
                                    <tr>
                                        <th>Course</th>
                                        <th>Level </th>
                                        <th>Title </th>
                                        <th>Date of Qualification </th>
                                        <th>Expiry Date</th>
                                        <th>Upload</th>
                                        <th></th>
                                    </tr>
                                    {
                                        fields.map((training , index)=>{
                                            return <tr key={training.id}>
                                                <td>
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            placeholder="Course"
                                                            className="form-control"
                                                            {...register(`training_other_courses.${index}.other_qualification_course`)}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            placeholder="Level"
                                                            className="form-control"
                                                            {...register(`training_other_courses.${index}.other_qualification_level`)}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            placeholder="Title"
                                                            className="form-control"
                                                            {...register(`training_other_courses.${index}.other_qualification_title`)}
                                                        />
                                                    </div>
                                                </td>

                                                {/* <td>
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            placeholder="Select Date"
                                                            className="form-control"
                                                            {...register(`training_other_courses.${index}.other_qualification_date`)}
                                                        />
                                                    </div>
                                                </td> */}

                                                <td>
                                                    <DateInput
                                                        parentClassName="mw-100 col-md"
                                                        handleOnDateChange={(e) => handleOnDateChange(e, `training_other_courses.${index}.other_qualification_date`)}
                                                        name={`training_other_courses.${index}.other_qualification_date`}
                                                        value={watch(`training_other_courses.${index}.other_qualification_date`)} 
                                                    />
                                                </td>

                                                {/* <td>
                                                    <div className="renewal_sec">
                                                        <div className="col-lg-1 form-group">
                                                            <input type="checkbox" />
                                                        </div>
                                                        <div className="col-lg-11 form-group">
                                                            <input
                                                                type="text"
                                                                placeholder="Select Date"
                                                                className="form-control"
                                                                {...register(`training_other_courses.${index}.other_qualification_date_expiry`)}
                                                                
                                                            />
                                                        </div>
                                                    </div>
                                                </td> */}

                                                <td>
                                                    <div className="renewal_sec">
                                                        <div className="col-lg-1 form-group">
                                                            <input type="checkbox" {...register(`training_other_courses.${index}.renewal`, { value: Boolean(getValues(`training_other_courses.${index}.other_qualification_date_expiry`)) })} />
                                                        </div>
                                                        {
                                                            watch(`training_other_courses.${index}.renewal`) &&
                                                            <DateInput
                                                                parentClassName="mw-100 col-md-12"
                                                                handleOnDateChange={(e) => handleOnDateChange(e, `training_other_courses.${index}.other_qualification_date_expiry`)}
                                                                name={`training_other_courses.${index}.other_qualification_date_expiry`}
                                                                value={watch(`training_other_courses.${index}.other_qualification_date_expiry`)}
                                                            />

                                                        }

                                                    </div>
                                                </td>



                                                <td>
                                                    {
                                                        !Boolean(watch(`training_other_courses.${index}.filePath`))
                                                            ? <div className="up_img">
                                                                <label>
                                                                    <img src={Upload} style={{ cursor: 'pointer' }} alt="" className={`${"upload_isdisable" ? "" : 'uploadfile-disabled'}`} />
                                                                    <input className="d-none" /* disabled={!upload_isdisable}*/ type="file" accept="application/pdf,.pdf,image/*" onChange={(e) => handleOnFilesChange(e, `training_other_courses.${index}`)} />
                                                                </label>
                                                            </div>
                                                            : <FileViewEmployment url={getValues(`training_other_courses.${index}.filePath`)} onClick={(url) => toggleImageViewer(url)} onDelete={(url) => handleOnDeleteFile(`training_other_courses.${index}.filePath`, url)} />
                                                    }
                                                </td>
                                                
                                                <td>
                                                    <Button className="table-close" onClick={()=>handleOnRemove(index , training)}>x</Button>
                                                </td>
                                            </tr>
                                        })
                                    }

                                </table>
                            </div>
                         </div>
                        : <></>                   
                    }

                    <div className="position-relative col-12 col-md-12">
                        <Button className="add-row" onClick={()=>append(intialTarining)}>+</Button>
                    </div>

                    <div className="col-12 col-md-12 sub_paragraph">
                        <p>
                            If you cannot provide evidence for mandatory training (if
                            needed for the role) you will have to complete the
                            relevant training before starting work.
                        </p>
                    </div>
                </div>
                <NextButton />
            </Form>
            <ImageViewModel filepath={Viewer.viewUrl} isOpen={Viewer.isPreview} toggle={toggleImageViewer} />

        </>
    )
}


const ProfessionalMemberships = (props =initailState) => {
    
    const { toggleAccordion , handleSetToast , updateForm ,toggleTab } = props ;

	const intialMembership = {
        // "_id": "",
        "professionalBody": "",
        "pinRef": "",
        "professionalBodyExpiry": "",
        "fileName": "",
        "filePath": ""
    };

	const { control, register , getValues , watch ,reset, handleSubmit ,setValue ,formState } = useForm({
		values:{
			professional_Body: props.professional_Body
		}
	});

	const { fields, append, remove} = useFieldArray({
	  control, // control props comes from useForm (optional: if you are using FormContext)
	  name: "professional_Body", // unique name for your Field Array

	});


    const initialViewer = {
        viewUrl:"",
        isPreview:false
    }

    const [Viewer , setViewer]  = useState(initialViewer)



    const toggleImageViewer = (url = '') =>{
        url = String(url).startsWith('uploads/images') ? `${NodeURL}/${url}` : ''
        setViewer((prev)=>({...prev , viewUrl:url, isPreview:!prev.isPreview}))
    }


    const removeProfessional_Body = async (id = '') => {
        try {
            const res = await request({ url: "/candidate/form/delete/professional_body", method: "post", data: { "_id": id } })
            return res.status;
        } catch (error) {
            return 0
        }
    }


	const handleOnDateChange = (e ='' ,name='') => {
        let _date = isValidDate(e) ? moment(e): '';
        isValidDate(e) &&  setValue(name,_date ,{shouldDirty:true})
    }

        // ["pdf" , "png" ,"jpeg" ,"jpg"].includes(temp1.type))slice('dddddimage/png'.search("/"))
    const handleOnFilesChange = async (e = {} ,name = '') =>{
        let files = (e && e.target && e.target.files) ? e.target.files : [];
            files = files.length ? files[0] : null;

        if(!files) return;
        if(!(files.size < 5242880)){
            return toast.error("Maximum upload size is 5MB");
        }
        if(!["pdf" , "png" ,"jpeg" ,"jpg"].includes(files.type.slice(files.type.search("/") + 1))){
            return toast.error("File Format not supported");
        }
            let data = createFormData({upload_doc : files})
            let url = await addfileToServer(data);

            url && setValue(`${name}.fileName` ,files.name );
            url && setValue(`${name}.filePath` , url);
            toast.success("File Uploaded" , {autoClose:2000})

    }

    const handleOnRemove = (index , professional = {}) =>{
        if(professional._id){
            removeProfessional_Body(professional._id).then((status)=>{
                if(status === 1){
                    remove(index);
                    handleSetToast("formupdate" , "Removed!" ,"success")                  
                }
            })
        }else{
            remove(index)
        }
    }

    const handleOnDeleteFile = (name = '' ) =>{
        setValue(name ,'');
        toast.success("File Removed" , {autoClose:2000})
    }
    


    const onFormSubmit = (data = {}) => {;
        let professional_Body = JSON.stringify(IsArray(data.professional_Body) ? data.professional_Body : []);
        if (updateForm) {
            updateForm({ professional_Body, setctionId: "professional_body_memberships" }).then((res={}) => {
                reset({},{ keepDirty:false })
                if(res.result && res.result.professional_Body && IsArray(res.result.professional_Body)){
                    setValue('professional_Body' ,res.result.professional_Body ,{shouldDirty:false})
                }
                handleSetToast && handleSetToast("formupdate", "saved!", "success")
            })
        }
    }

    const handleOnContinue = async () =>{
        if(formState.isDirty){
            onFormSubmit(getValues())
        }
        toggleTab("submenu" , "3")
	}

    return (
        <>
            <Form onSubmit={handleSubmit(onFormSubmit)}>
                <div className="emp_edu">
                    <p className="p-3 title_sub">
                        Please add details of professional bodies that you are
                        affiliated with, eg NMC, SWE etc.
                    </p>
                    {
                        IsArray(getValues("professional_Body")) && getValues("professional_Body").length > 0 &&
                        <div className="position-relative col-12 col-md-12">
                            <div className="new-table hiding-calendar">
                                <table className="table">
                                    <tr>
                                        <th>Body/Institution/Description</th>
                                        <th>PIN/REF </th>
                                        <th>Expiry Date </th>
                                        <th>Upload</th>
                                        <th></th>
                                    </tr>
                                    {
                                        fields.map((member , index)=>{
                                            return <tr key={member.id}>
                                                <td>
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            placeholder="NMC/HCPC/GMC"
                                                            className="form-control"
                                                            {...register(`professional_Body.${index}.professionalBody`)}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            placeholder="99A9999A"
                                                            className="form-control"
                                                            {...register(`professional_Body.${index}.pinRef`)}
                                                        />
                                                    </div>
                                                </td>

                                                <td>
                                                    <DateInput
                                                        parentClassName="mw-100 col-md"
                                                        handleOnDateChange={(e) => handleOnDateChange(e, `professional_Body.${index}.professionalBodyExpiry`)}
                                                        name={`professional_Body.${index}.professionalBodyExpiry`}
                                                        value={watch(`professional_Body.${index}.professionalBodyExpiry`)}
                                                    />
                                                </td>

                                                <td>
                                                    {
                                                        !Boolean(watch(`professional_Body.${index}.filePath`))
                                                            ? <div className="up_img">
                                                                <label>
                                                                    <img src={Upload} style={{ cursor: 'pointer' }} alt="" className={`${"upload_isdisable" ? "" : 'uploadfile-disabled'}`} />
                                                                    <input className="d-none" /* disabled={!upload_isdisable}*/ type="file" accept="application/pdf,.pdf,image/*" onChange={(e) => handleOnFilesChange(e, `professional_Body.${index}`)} />
                                                                </label>
                                                            </div>
                                                            : <FileViewEmployment url={getValues(`professional_Body.${index}.filePath`)} onClick={(url) => toggleImageViewer(url)} onDelete={(url) => handleOnDeleteFile(`professional_Body.${index}.filePath`, url)} />
                                                    }
                                                </td>

                                                <td>
                                                    <Button className="table-close" onClick={()=>handleOnRemove(index , member)} >x</Button>
                                                </td>
                                            </tr>
                                        })
                                    }
                                </table>
                            </div>
                        </div>
                    }
                    
                    <div className="position-relative col-12 col-md-12">
                        <Button className="add-row" onClick={()=>append(intialMembership)} >+</Button>
                    </div>
                </div>
                {/* <NextButton /> */}
                <div className="position-relative col-12 col-md-12">
                    <div className="text-center" id="s-c-buttons">
                        <Button type="submit" className={`${formState.isDirty ? "" : "cursor-no-drop"} btn-save`} disabled={!formState.isDirty} >Save</Button>
                        <Button type="button" onClick={handleOnContinue}>Continue</Button>
                    </div>
                </div>
            </Form>

            <ImageViewModel filepath={Viewer.viewUrl} isOpen={Viewer.isPreview} toggle={toggleImageViewer} />
        </>
    )
}







// Skills & Work History tab sub menu 3 



const SkillsAndWorkHistory = (props = initailState) => {
    
    
    const { toggleAccordion , handleSetToast , updateForm ,toggleTab } = props ;

	const intialWorkhistory = {
        "work_title": "",
        "employer": "",
        "work_from_date": "",
        "work_to_date": ""
    };

	const { control, register , getValues , watch , handleSubmit ,setValue , formState ,reset} = useForm({
		values:{
			work_experience: props.work_experience,
            skills:props.skills,
            languages:props.languages,
            skillProvideDetails:props.skillProvideDetails
		}
	});

	const { fields, append, remove} = useFieldArray({
	  control, // control props comes from useForm (optional: if you are using FormContext)
	  name: "work_experience", // unique name for your Field Array,
	});


    const initialskillsAndLang = {
        skills:{
            addList:false,
            Lists:[],
            selectedList: [],
            value:""
        },
        lang:{
            addList:false,
            Lists:[],
            selectedList:[],
            value:""
        }
    }
    const [ work ,setWork ] = useState(initialskillsAndLang);




    useEffect(()=>{
        setWork((prv)=>({
            ...prv,
            skills:{
                ...prv.skills,
                selectedList:IsArray(props.skills) ? props.skills.map((item)=>({_id:item._id , value:item.skills_title , key:item.skills_title})) : []
            }
        }))
    },[props.skills])
    
    useEffect(()=>{
        setWork((prv)=>({
            ...prv,
            lang:{
                ...prv.lang,
                selectedList:IsArray(props.languages) ? props.languages.map((item)=>({_id:item._id , value:item.languages_title , key:item.languages_title})) : []
            }
        }))
    },[props.languages])


    useEffect(()=>{
        onSkillSearch()
    },[work.skills.value])



    const onSkillSearch = () => {
		request({
			url: "/employee/searchSkills",
			method: "POST",
			data: { addedBy: "agency", name: work.skills.value},
		}).then((res) => {
			if (res.status === 1) {
				const skillData = res.result.map((item, i) => {
					return { key: item.name, value: item.name };
				});
				setWork((prev)=>({...prev ,skills:{...prev.skills , Lists:skillData}}))
			} else if (res.status === 0) {
				toast.error(res.response);
			}
		});
	};

    const onAddNewLanguage = (e) => {
		// e.stopPropagation();
		if (!work.lang.value) {
			toast.error("Please Fill to Add Language");
		} else {
			request({
				url: "/administrators/employee/addNewLanguages",
				method: "POST",
				data: { addedBy: "agency", name:work.lang.value },
			}).then((res) => {
				if (res.status === 1) {
					toast.success("Added");
					this.onAddLanguages(null, this.state.language_search);
				} else if (res.status === 0) {
					toast.error(res.response);
				}
			});
		}
	};



	const handleOnDateChange = (e ='' ,name='') => {
        let _date = isValidDate(e) ? moment(e): '';
        isValidDate(e) &&  setValue(name,_date , {shouldDirty:true})
    }

    const handleOnRemove = (index) =>{
        remove(index);
    }
    

    const onFormSubmit = (data = {}) => {
        let work_experience = IsArray(data.work_experience) ? data.work_experience.filter((item)=>Boolean(item.employer && item.work_title)) : [],
            skillProvideDetails = data.skillProvideDetails;
            work_experience = JSON.stringify(IsArray(work_experience) ? work_experience : []);

        if (updateForm) {
            updateForm({ work_experience,skillProvideDetails, setctionId: "skills_work_history" }).then((res={}) => {
                reset({},{ keepDirty:false })
                if(res.result && res.result.work_experience && IsArray(res.result.work_experience)){
                    setValue('work_experience' ,res.result.work_experience , {shouldDirty:false})
                }
                handleSetToast && handleSetToast("formupdate", "saved!", "success")
            })
        }
    }

    const handleOnContinue = async () =>{
        if(formState.isDirty){
            onFormSubmit(getValues())
        }
		toggleTab("submenu" , "4")
	}



    return (
        <Form onSubmit={handleSubmit(onFormSubmit)}>
            <div className="skill_history">

                <div className="emp_edu work_history p-3">
                    <h5>Work history</h5>
                    <p>
                        Please ensure you complete this section. Please ensure that you
                        leave no gaps unaccounted for and it covers full work history
                        including your education.
                    </p>
                    <ul>
                        <li>1. Full work history including your education</li>
                        <li>2. Dates to and from should be continual with NO gaps</li>
                        <li>
                            3. Month and year should be sufficient if exact date is not
                            available , any date in that month can be selected
                        </li>
                        <li>
                            4. Where there have been gaps in work history please state the
                            reason for the gaps
                        </li>
                        <li>
                            5. Lists all relevant training undertaken in the section below
                        </li>
                    </ul>
                    {
                        IsArray(getValues("work_experience")) && getValues("work_experience").length > 0 &&
                        <div className="position-relative col-12 col-md-12">
                            <div className="new-table hiding-calendar">
                                <table className="table">
                                    <tr>
                                        <th>Work Title</th>
                                        <th>Employer</th>
                                        <th>From Date</th>
                                        <th>To Date</th>
                                        <th></th>
                                    </tr>
                                        {
                                            fields.map((work, index) => {
                                                return <tr key={work.id}>
                                                    <td>
                                                        <div className="form-group">
                                                            <input type="text" className="form-control" {...register(`work_experience.${index}.work_title`)} />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="form-group">
                                                            <input type="text" className="form-control" {...register(`work_experience.${index}.employer`)}  />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <DateInput
                                                            parentClassName="mw-100 col-md"
                                                            handleOnDateChange={(e) => handleOnDateChange(e, `work_experience.${index}.work_from_date`)}
                                                            name={`work_experience.${index}.work_from_date`}
                                                            value={watch(`work_experience.${index}.work_from_date`)} 
                                                        />
                                                    </td>

                                                    <td>
                                                        <DateInput
                                                            parentClassName="mw-100 col-md"
                                                            handleOnDateChange={(e) => handleOnDateChange(e, `work_experience.${index}.work_to_date`)}
                                                            name={`work_experience.${index}.work_to_date`}
                                                            value={watch(`work_experience.${index}.work_to_date`)} 
                                                        />
                                                    </td>

                                                    {/* <td>
                                                        <div className="form-group">
                                                            <input
                                                                type="text"
                                                                placeholder="Select Date"
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    </td> */}
                                                    {/* <td>
                                                        <div className="form-group">
                                                            <input
                                                                type="text"
                                                                placeholder="Select Date"
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    </td> */}


                                                    <td>
                                                        <Button type="button" className="table-close" onClick={()=>handleOnRemove(index)}>x</Button>
                                                    </td>
                                                </tr>
                                            })
                                        }
                                </table>
                            </div>
                        </div>
                    }
                    <div class="position-relative col-12 col-md-12">
                        <button type="button" class="add-row btn btn-secondary" onClick={()=>append(intialWorkhistory)}>+</button>
                    </div>


                </div>


                <div className="provide_detail">

                    <h5 className="p-3">Provide Details Of Gaps If Any</h5>

                    {/* <TextAreaInput label="Details" {...register("skillProvideDetails")} />
                     */}
                    <div className="position-relative col-12 col-md-12">
                        <div className="form-group">
                            <label>Details</label>
                            <textarea  placeholder="Provide Details" {...register("skillProvideDetails")} ></textarea>
                        </div>
                    </div>


                    <div className="provide_detail_two">
                        {/* <SkillsAndLang work={work} setWork={setWork} /> */}
                    </div>


                </div>


            </div>
            <div className="position-relative col-12 col-md-12">
                <div className="text-center three_button" id="s-c-buttons">
                    <Button type="button" onClick={()=>toggleTab("submenu" , '2')} >
                        <i class="fa fa-chevron-circle-left" aria-hidden="true"></i>{" "}
                        Previous
                    </Button>
                    <Button className={`${formState.isDirty ? "" : 'cursor-no-drop'} btn-save`} disabled={!formState.isDirty}>Save</Button>
                    <Button type="button" onClick={handleOnContinue}>Continue</Button>
                </div>
            </div>
        </Form>
    )
}





function SkillsAndLang({ work = {}, setWork = ()=>{} }) {

    // const initialskillsAndLang = {
    //     skills:{
    //         addList:false,
    //         Lists:[],
    //         selectedList:[],
    //         value:""
    //     },
    //     lang:{
    //         addList:false,
    //         Lists:[],
    //         selectedList:[],
    //         value:""
    //     }
    // }
    // const [ work ,setWork ] = useState(initialskillsAndLang)




    
    /**
     * 
     * @param {*} e 
     * @param {"skills" | "lang"} key 
     * @param {string} item 
     */
    const handleOnChange = (e , key='skills') =>{
        let value = e && e.target && e.target.value;
        setWork((prev) =>({...prev , [key]:{...prev[key] ,value  }}))

    }
    /**
     * 
     * @param {*} e 
     * @param {"skills" | "lang"} key
     * @param {*} item 
     */
    const handleDataList = async (e , key='skills' ,view = true )=>{
        setWork((prev = {})=>({...prev , [key]:{...prev[key] , addList:view} }));
    }


    /**
     * Handle on slelet 
     * @param {*} e 
     * @param {"skills" | "lang"} key 
     * @param {*} item 
     */
    const handleOnselect = (e, key = "skills", item) => {

        let value = (item && item.value) || ""
      setWork((prev) => ({
        ...prev,
        [key]: {
          ...prev[key],
        //   selectedList: [...new Set([...prev[key].selectedList, item])],
          selectedList: prev[key].selectedList.map(i=>i.value).includes(value) ? prev[key].selectedList : [...prev[key].selectedList , item] ,
          addList:false
        },
      }));
    };


    /**
     * 
     * @param {*} e 
     * @param {"skills" | "lang"} key 
     * @param {*} item 
     */
    const handleOnAddNew = (e, key = "skills") => {
        if(!(work[key].value.trim())) return;
      
    //     setWork((prev) => ({
    //     ...prev,
    //     [key]: {
    //       ...prev[key],
    //       selectedList:IsArray(prev[key].selectedList) && prev[key].selectedList.map((i={})=>i.skills_title).includes(prev[key].value) ? prev[key].selectedList :[...prev[key].selectedList , ]  ,
    //     //   selectedList: [...new Set([...prev[key].selectedList , prev[key].value ])],
    //       addList:false,
    //       value:""
    //     }, 
    //   }));
    };

    /**
     * 
     * @param {*} e 
     * @param {"skills" | "lang"} key 
     * @param {*} item 
     */
    const handleOnRemove = (e , index , key = 'skills')=>{
      setWork((prev) => ({
        ...prev,
        [key]: {
          ...prev[key],
          selectedList:prev[key].selectedList.filter((_ ,i)=>i !== index),
          addList:false,
          value:""
        }, 
      }));
    }



    // const handleKeyDown = (event ,key ='skills') => {
    //     switch (event.key) {
    //     case "Enter":
    //         handleOnAddNew({} , key )
    //     }
    // };


  return (
    <div className="sens-infos pad-ext">
      <Col xs="12" md="6">
        <Label>Skills</Label>
        <input
          id="myInput_skill"
          type="search"
          name="skill_search"
          placeholder="... start typing to search or Add New Skill"
          autoComplete="nope"
          value={work.skills.value}
          onFocus={(e)=>handleDataList(e ,'skills')}
          onChange={(e)=>handleOnChange(e , "skills")}
        //   onBlur={(e)=>handleDataList(e , "skills" ,false)}
        //   onKeyDown={(e)=>handleKeyDown(e , 'skills')}
        // onFocusCapture={}
        />
        <ul
          className={`myULsearch_skill p-relative ${ work.skills.addList ? "none-display_skill" :""}`} >
          {
          work.skills.Lists.map((item ={}, i) =><li key={i}> <a onClick={(e) =>handleOnselect(e , 'skills' , item) } > {item.value} </a> </li>)
          }
          <li>
            <a onClick={(e)=>handleOnAddNew(e ,'skills')} className="add-new-grade">
              + Add New Skill
            </a>
          </li>
        </ul>
        <div className="uppend-divs mb-5"><SkillsAndLangList Lists={work.skills.selectedList} onRemoveItem={(e ,index )=>handleOnRemove(e , index ,'skills')} /> </div>
      </Col>

      <Col xs="12" md="6">
        <Label>Languages</Label>
        <input
          id="myInput_skill"
          type="search"
          name="lang_search"
          placeholder="... start typing to search or Add New Language"
          autoComplete="nope"
          value={work.lang.value}
        //   onSelect={}
          onFocus={(e)=>handleDataList(e ,'lang')}
          onChange={(e)=>handleOnChange(e , "lang")}
        />
        <ul
          className={`myULsearch_skill p-relative ${ work.lang.addList ? "none-display_skill" :""}`} >
          {
          work.lang.Lists.map((item, i) =><li key={i}> <a onClick={(e) =>handleOnselect(e , 'lang' , item) } > {item.value} </a> </li>)
          }
          <li>
            <a onClick={(e)=>handleOnAddNew(e ,'lang' , )} className="add-new-grade">
              + Add New Language 
            </a>
          </li>
        </ul>
        {/* <div className="uppend-divs mb-5"><SkillsAndLangList Lists={work.lang.selectedList} onRemoveItem={(e ,index )=>handleOnRemove(e , index ,'lang')} /> </div> */}
      </Col>
    </div>
  );
}

function SkillsAndLangList({Lists = [] ,onRemoveItem = ()=>{} }) {
  return<TernaryComponent
    condition={Lists && Lists.length > 0}
    IFTRUE={Lists.map((item , i) => (
      <span key={i}>
        {item.value}
        <div className="uppend-abs" >
          <i className="fa fa-minus-circle cursor-pointer" aria-hidden="true" onClick={(e)=>{ e.stopPropagation();onRemoveItem(item ,i); }} />
        </div>
      </span>
    ))}
  />
}









// Declaration {"&"} Terms



/*

    working_time_regulation:0,
    health_declaration:1,
    personal_declaration:2,
    confidentiality:3,
    rehabilitation:4,
    disclosure_barring_service:5,
    health_safety:6,
    application_declaration:7



    heading 

    DEFINITIONS
    
    WORKING TIME REGULATIONS *

    HEALTH DECLARATION
    
    PERSONAL DECLARATION

    CONFIDENTIALITY

    REHABILITATION OF OFFENDERS ACT 1974 & CRIMINAL RECORDS

    Disclosure Barring Service (DBS)

    HEALTH & SAFETY

    ID & INDEMNITY VERIFICATION

    DISABILITY & DISCRIMINATION ACT 1985

    APPLICATION FORM DECLARATION *




*/
const declarationterms_schema = yup.object().shape({
    workTimeSignature:yup.string().required('Worktime signature is Required'),
    signature:yup.string().required('Signature is Required'),
})
const DeclarationTerms = (props = initailState) => {

    const { toggleAccordion , handleSetToast , updateForm ,toggleTab , open:active_accordion , handleaccordion=()=>{} ,   firstname , lastname ,agencydata={}, } = props ;
    let fullName = `${firstname || ""} ${lastname || "" }`,
        agencyName = (agencydata && agencydata.company_name) || "";


    const {register , handleSubmit , setValue , getValues , watch , formState , reset ,trigger ,} = useForm({
		values:{
            // WORKING TIME REGULATIONS *  tab sub menu 
            workTimeDate:props.workTimeDate || "",
            workTimeSignature:props.workTimeSignature || "",

            // HEALTH DECLARATION
            acceptHealthDeclaration:props.acceptHealthDeclaration || "",
            HealthDeclarationDate:props.HealthDeclarationDate || "",

            // PERSONAL DECLARATION
            acceptPersonalDeclaration:props.acceptPersonalDeclaration || "",
            PersonalDeclarationDate:props.PersonalDeclarationDate || "",

            // CONFIDENTIALITY
            ConfidentialityDate:props.ConfidentialityDate || "",
            acceptConfidentiality:props.acceptConfidentiality || "",

            // REHABILITATION OF OFFENDERS ACT 1974 & CRIMINAL RECORDS
            criminaloffence:props.criminaloffence || "",
            criminalCautioned:props.criminalCautioned || "",
            criminalConvictions:props.criminalConvictions || "",
            criminalCourt:props.criminalCourt || "",
            criminalDisciplinaryAction:props.criminalDisciplinaryAction || "",
            criminalAdditionalInformation:props.criminalAdditionalInformation || "",

            // "Disclosure Barring Service (DBS)
            dbsAccept:props.dbsAccept || "",
            dbsAcceptDate:props.dbsAcceptDate || "",

            // DISABILITY & DISCRIMINATION ACT 1985
            registereddisabled:props.registereddisabled || "",
            // if registereddisabled equals yes
            disableRegisteredDetails:props.disableRegisteredDetails || "",

            disableAct:props.disableAct || "",
            // if disableAct equals yes
            disableActDetails:props.disableActDetails || "",

            disableOverCome:props.disableOverCome || "",
            // if disableOverCome equal yes
            disableOverComeDetails:props.disableOverComeDetails || "",


            // APPLICATION FORM DECLARATION
            declarationAccept:props.declarationAccept || "",
            declarationAcceptDate:props.declarationAcceptDate || "",
            signature:props.signature || "",
        },
		resolver:yupResolver(declarationterms_schema)
	}),
	{ errors } = formState;

    const _watch_workTimeSignature  =  watch('workTimeSignature','');
    const _watch_signature  =  watch('signature','');

    const [signModal, setSignModal] = useState(false);
    const [signtype ,setSignType] = useState("")


    const toggleSignModal = (signType='') => {
        setSignModal(!signModal);
        if(['workTimeSignature','signature'].includes(signType)){
            setSignType(signType)
        }
        
    };
    const handleSignatureDrawSave = (url , signType) => {

        if("workTimeSignature" === signType){
            setValue('workTimeSignature',url,{shouldDirty:true})
        }else{
            setValue('signature',url , {shouldDirty:true})
        }

    };

    const handleOnDateChange = (e ='' ,name='') => {
        let _date = isValidDate(e) ? moment(e): '';
        isValidDate(e) &&  setValue(name,_date , {shouldDirty:true})
    }

    const onFormSubmit = (data = {}) => {
        if (updateForm) {
            updateForm({ ...data, setctionId: "declaration_terms" }).then((res={}) => {
                // if(res.result && res.result.work_experience && IsArray(res.result.work_experience)){ }
                reset({},{keepDirty:false ,keepValues:true})
                handleSetToast && handleSetToast("formupdate", "saved!", "success")
            })
        }
    }
    const OnFormError =(e={})=>{
        console.log(e)
        if(e && e.workTimeSignature){
            return handleSetToast && handleSetToast("formupdate", e.workTimeSignature.message , "error")
        }
        if(e && e.signature){
            return handleSetToast && handleSetToast("formupdate", e.signature.message , "error")
        }
        
    }

    const handleOnContinue =  () =>{
        // if(formState.isDirty){
            onFormSubmit(getValues())
        // }
		toggleTab("menu", "2")
	}
    const handleOnNext = async () =>{
        const workTimeSignature_err = await trigger('workTimeSignature');
        console.log(workTimeSignature_err , errors)
        if(!workTimeSignature_err && errors.workTimeSignature && errors.workTimeSignature.message ){
            handleSetToast && handleSetToast("formupdate", errors.workTimeSignature.message , "error")
        }else{
            toggleAccordion("health_declaration" , "declaration_terms")
        }
    }
 
    return (
        <>
        { signModal &&  <SignaturePadModel isOpen={signModal} toggle={toggleSignModal} signTypeId={signtype} signValue={signtype ==='workTimeSignature' ? _watch_workTimeSignature : _watch_signature} onSignature={handleSignatureDrawSave} />}
            <Form onSubmit={handleSubmit(onFormSubmit , OnFormError)} >
                <Accordion open={active_accordion} toggleAccordion={handleaccordion}>


                    <Accordion.Item>
                        <Accordion.Header>Working Time Regulation*</Accordion.Header>
                        <Accordion.Body>
                            <div className="position-relative col-12 col-md-12">
                                <p>
                                    The Working Time Regulations of 1998 state that a Temporary
                                    Worker shall not work on an Assignment with a client in
                                    excess of the Working Week unless they agree in writing that
                                    this limit should not apply. The Temporary worker, by
                                    signing the declaration below, agrees that the Working Week
                                    shall not apply to their Assignments.
                                </p>
                                <p>
                                    The Temporary Worker can end this Agreement at anytime by
                                    giving the Employment Business 14 days notice in writing.
                                    After the 14 day notice period has expired the Working Week
                                    shall apply immediately. It should be noted, that any notice
                                    ending this Agreement does not mean that a Temporary Worker
                                    has ended an Assignment with a Client.
                                </p>
                                <p>
                                    In addition, I also consent to work in excess of the maximum
                                    number of hours permitted to work at night under the
                                    directive. Please note you are under no obligation to sign
                                    either declaration.
                                </p>
                                <p>
                                    These laws are governed by English Law and are subject to
                                    the jurisdiction of the English Courts.
                                </p>
                                <div className="position-relative col-12 col-md-12 p-0 mt-3">
                                    <div className="form-group click_button">
                                        {/* <label>Details</label> */}
                                        {/* <Input type="date" /> */}

                                        <DateInput  name="workTimeDate" handleOnDateChange={handleOnDateChange} value={watch("workTimeDate")}/>
                                        
                                        {/* <button className="click_sign">Click To Sign</button> */}
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0">
                                <div className="position-relative col-md-3">
                                    <button type="button" className="sign-modal" onClick={()=>toggleSignModal("workTimeSignature")}>{!_watch_workTimeSignature ? "Click to Signature":"Replace the Signature"}</button>
                                
                                </div>
                                <SignatureView signValue={_watch_workTimeSignature} />
                            </div>
                    
                            <NextButton type={"button"} onClick={()=>handleOnNext()}/>
                        </Accordion.Body>
                    </Accordion.Item>


                    <Accordion.Item>
                        <Accordion.Header>Health Declaration</Accordion.Header>
                        <Accordion.Body>
                            <div className="position-relative col-12 col-md-12">
                                <p>
                                    The purpose of the questionnaire and declaration is to
                                    establish whether you have any health problems that could
                                    affect your ability to undertake the duties of the post you
                                    have been offered or place you at any risk in the workplace.
                                    We may recommend adjustments or assistance as a result of
                                    this assessment to enable you to do the job. Our aim is to
                                    promote and maintain the health of all people at work.
                                    Before health clearance is given for employment you may be
                                    contacted by our nominated occupational health service
                                    provider and may need to be seen by an occupational health
                                    advisor or physician. Your record will be held on file for a
                                    short period of time and may be subject to audit.
                                </p>
                                <p>
                                    I { fullName } consent to {agencyName } releasing my
                                    health and immunisation records for review to { agencyName } qualified Occupational Health Advisor.
                                </p>
                                <p>
                                    I understand that based on this review I may be required to
                                    undergo a medical examination to establish my fitness for
                                    work.
                                </p>
                                <p>
                                    I agree to immediately inform { agencyName } should my
                                    general condition of health change. I will inform { agencyName } immediately if I discover that I am pregnant. I
                                    understand that withholding information or giving false
                                    answers may lead to dismissal.
                                </p>
                                <div className="position-relative col-12 col-md-12 p-0 mt-3">
                                    <div className="form-group click_button">
                                        {/* <label>Details</label> */}
                                        {/* <Input type="date" /> */}
                                        <DateInput  name="HealthDeclarationDate" handleOnDateChange={handleOnDateChange} value={watch("HealthDeclarationDate")}/>
                                    </div>
                                </div>
                            </div>
                            <NextButton type={"button"} onClick={()=>toggleAccordion("personal_declaration" , "declaration_terms")}/>
                        </Accordion.Body>
                    </Accordion.Item>


                    <Accordion.Item>
                        <Accordion.Header>Personal Declaration</Accordion.Header>
                        <Accordion.Body>
                            <div className="position-relative col-12 col-md-12">
                                <p>
                                    Thereby confirm that the information provided on my
                                    application is correct and true to the best of my knowledge
                                    and that I have not withheld any information that should be
                                    taken into account when offering me work.
                                </p>
                                <p>
                                    I understand that providing false or inaccurate information
                                    may result in the termination of any placement.
                                </p>
                                <p>
                                    I agree that I will make best endeavours to make myself
                                    aware of the Health {"&"} Safety procedures for each client I am
                                    assigned to.
                                </p>
                                <p>
                                    I confirm that I have read and understood the Terms of
                                    Engagement and the terms of the declaration and agree to be
                                    bound by them.
                                </p>
                                <p>
                                    { agencyName } retains the right to hold this
                                    application and any other data required to process this
                                    application (whether in the UK, European Union or elsewhere)
                                    and keep for as long as necessary in line with the data
                                    protection act.
                                </p>
                                <p>
                                    I consent to { agencyName } checking the details I have
                                    provided against the various data sources in order to verify
                                    my identity and process the application. These details may
                                    be recorded and used to assist other organisations for
                                    identity verification purposes such as the DBS and
                                    regulatory bodies such as NMC or GSCC.
                                </p>
                                <CheckBoxInput {...register("acceptPersonalDeclaration")} />
                                <div className="position-relative col-12 col-md-12 p-0 mt-3">
                                    <div className="form-group click_button">
                                        {/* <Input type="date" /> */}
                                        <DateInput  name="PersonalDeclarationDate" handleOnDateChange={handleOnDateChange} value={watch("PersonalDeclarationDate")}/>
                                    </div>
                                </div>
                            </div>

                            <NextButton type={"button"} onClick={()=>toggleAccordion("confidentiality" , "declaration_terms")}/>
                        </Accordion.Body>
                    </Accordion.Item>


                    <Accordion.Item>
                        <Accordion.Header>Confidentiality</Accordion.Header>
                        <Accordion.Body>
                            <div className="position-relative col-12 col-md-12">
                                <p>
                                    I hereby declare that at no time will I divulge to any
                                    person, nor use for my own or any other person’s benefit,
                                    any confidential information in relation to the Client or { agencyName } or in relation to any of their
                                    employees, business affairs, transactions or finances which
                                    I may acquire during the term of my agreement with { agencyName } under the Terms of Engagement.
                                </p>
                                <CheckBoxInput {...register("acceptConfidentiality")} /> 
                                <div className="position-relative col-12 col-md-12 p-0 mt-3">
                                    <div className="form-group click_button">
                                        {/* <Input type="date" /> */}
                                        <DateInput  name="ConfidentialityDate" handleOnDateChange={handleOnDateChange} value={watch("ConfidentialityDate")}/>
                                    </div>
                                </div>
                            </div>
                            <NextButton type={"button"} onClick={()=>toggleAccordion("rehabilitation" , "declaration_terms")}/>
                        </Accordion.Body>
                    </Accordion.Item>


                    <Accordion.Item>
                        <Accordion.Header>
                            REHABILITATION OF OFFENDERS ACT 1974 {"&"} CRIMINAL RECORDS
                        </Accordion.Header>
                        <Accordion.Body>

                            <div className="position-relative col-12 col-md-12 pb-3">
                                <p>
                                    By the virtue of the Rehabilitation of Offenders Act 1974 (Exemptions) (Amendments) Order 1986 the provision of section 4.2 of the Rehabilitation of Offenders Act 1974 do not apply to any employment which is concerned with the provision of health services and which is of such a kind to enable the holder to have access to persons in receipt of such services in the course of his/her normal duties. You are therefore, not entitled to withhold information about convictions which for other purposes are ‘spent’ under the provisions of the act and in the event of employment. You should therefore list all offences below even if you believe them to be ‘spent’ or ‘out of date’ for some other reason Failure to disclose such convictions could result in dismissal or disciplinary action.
                                    Any information given will be completely confidential and will be considered only in elation to an application for positions in which the order applies, and should be entered at the end of any particulars you give in support of your application. A copy of our written policies is available upon request. A criminal record will not necessary be a bar to obtaining a position.
                                </p>
                            </div>



                            <div className="d-flex flex-wrap check_box_sec ">

                            <YESORNO label="Have you been convicted of a criminal offence?" name="criminaloffence" register={register} />
                            
                            <YESORNO label="Have you ever been cautioned or issued with a formal warning for a criminal offence?" name="criminalCautioned" register={register} />
                            
                            <YESORNO label="Do you have any spent or unspent criminal convictions or cautions?" name="criminalConvictions" register={register} />
                            
                            <YESORNO label="Have you ever been involved in court proceedings?" name="criminalCourt" register={register} />

                            <YESORNO label="Have you ever had disciplinary action taken against you?" name="criminalDisciplinaryAction" register={register} />

                                {/* <div className="position-relative col-12 col-md-4 off_yes">
                                    <div className="form-group">
                                        <p>Have you been convicted of a criminal offence?</p>
                                        <ul>
                                            <li>
                                                <input type="radio" name="c_offence" /> Yes{" "}
                                            </li>
                                            <li>
                                                <input type="radio" name="c_offence" /> No{" "}
                                            </li>
                                        </ul>
                                    </div>
                                </div> */}


                                {/* <div className="position-relative col-12 col-md-4 off_yes">
                                    <div className="form-group">
                                        <p>
                                            Have you ever been cautioned or issued with a formal
                                            warning for a criminal offence?
                                        </p>
                                        <ul>
                                            <li>
                                                <input type="radio" name="c2_offence" /> Yes{" "}
                                            </li>
                                            <li>
                                                <input type="radio" name="c2_offence" /> No{" "}
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="position-relative col-12 col-md-4 off_yes">
                                    <div className="form-group">
                                        <p>
                                            Do you have any spent or unspent criminal convictions or
                                            cautions?
                                        </p>
                                        <ul>
                                            <li>
                                                <input type="radio" name="c3_offence" /> Yes{" "}
                                            </li>
                                            <li>
                                                <input type="radio" name="c3_offence" /> No{" "}
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="position-relative col-12 col-md-4 off_yes">
                                    <div className="form-group">
                                        <p>Have you ever been involved in court proceedings?</p>
                                        <ul>
                                            <li>
                                                <input type="radio" name="c4_offence" /> Yes{" "}
                                            </li>
                                            <li>
                                                <input type="radio" name="c4_offence" /> No{" "}
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="position-relative col-12 col-md-4 off_yes">
                                    <div className="form-group">
                                        <p>
                                            Have you been convicted of a criminal offence?Have you
                                            ever had disciplinary action taken against you?
                                        </p>
                                        <ul>
                                            <li>
                                                <input type="radio" name="c5_offence" /> Yes{" "}
                                            </li>
                                            <li>
                                                <input type="radio" name="c5_offence" /> No{" "}
                                            </li>
                                        </ul>
                                    </div>
                                </div> */}

                                {
                                watch(['criminaloffence' , "criminalCautioned" , "criminalConvictions" , "criminalCourt" ,'criminalDisciplinaryAction']).includes("yes") && 

                                <div className="position-relative col-12 col-md-12">
                                    <br />
                                    <div className="form-group provide_area">
                                        <p>
                                            Please give any additional information which you think
                                            may be relevant in support of your application on below.
                                        </p>
                                        <textarea {...register("criminalAdditionalInformation")} placeholder="Provide details"></textarea>
                                    </div>
                                </div>
                                }
                            </div>
                            <NextButton type={"button"} onClick={()=>toggleAccordion("disclosure_barring_service" , "declaration_terms")}/>
                        </Accordion.Body>
                    </Accordion.Item>


                    <Accordion.Item>
                        <Accordion.Header>
                            Disclosure Barring Service (DBS)
                        </Accordion.Header>
                        <Accordion.Body>
                            <div className="position-relative col-12 col-md-12">
                                <p>
                                    The Disclosure and Barring Service (DBS – formerly Criminal
                                    Records Bureau CRB) is the executive agency of the Home
                                    Office responsible for conducting checks on criminal
                                    records. We are registered body for receipt of DBS
                                    disclosure information. NHS Trust and Private Sector
                                    hospitals and nursing homes insist on agencies making
                                    information recruitment decisions which require DBS checks
                                    to be made on all staff.
                                </p>
                                <p>
                                    It is a condition of proceeding with your application that
                                    you apply for a DBS disclosure check. The disclosure will be
                                    compared with the information given above and any
                                    inconsistencies could invalidate your application or lead to
                                    the cancellation of your registration with us.
                                </p>
                                <p>
                                    I confirm the above is true and I understand that a DBS
                                    check will be sought in the event of a successful
                                    application
                                </p>
                                <CheckBoxInput {...register("dbsAccept")} />
                                <div className="position-relative col-12 col-md-12 p-0 mt-3">
                                    <div className="form-group click_button">
                                        {/* <Input type="date" /> */}
                                        <DateInput  name="dbsAcceptDate" handleOnDateChange={handleOnDateChange} value={watch("dbsAcceptDate")}/>
                                    </div>
                                </div>
                            </div>
                            <NextButton type={"button"} onClick={()=>toggleAccordion("health_safety" , "declaration_terms")}/>
                        </Accordion.Body>
                    </Accordion.Item>


                    <Accordion.Item>
                        <Accordion.Header>HEALTH {"&"} SAFETY</Accordion.Header>
                        <Accordion.Body>
                            <div className="position-relative col-12 col-md-12">
                                <p>
                                    Each agency worker has a responsibility at the start of
                                    their first shift to become familiar with the Client’s
                                    general policies including, without limitation, those
                                    relating to Crash Call Procedures, the Hot Spot Mechanism
                                    for alerting security staff that an individual is in
                                    trouble, Fire Policy and the Violent Episode Policy.
                                </p>
                            </div>
                            <NextButton type={"button"} onClick={()=>toggleAccordion("application_declaration" , "declaration_terms")}/>
                        </Accordion.Body>
                    </Accordion.Item>


                    <Accordion.Item>
                        <Accordion.Header>APPLICATION FORM DECLARATION</Accordion.Header>
                        <Accordion.Body>
                            <div className="position-relative col-12 col-md-12">
                                <p>Please Read Before Signing</p>
                                <p>
                                    I declare that by signing this form I am agreeing to
                                    declarations above . I am stating that I am legally entitled
                                    or allowed to work in the United Kingdom, with or without
                                    necessary permission from the Home Office or any other
                                    relevant authority. If I have secured permission to work, I
                                    have included copies of all documentation. I also
                                    acknowledge that if it is found that I am working without
                                    the relevant permission, my employment will be terminated
                                    with immediate effect and all details passed to the relevant
                                    authorities.
                                </p>
                                <p>
                                    I agree that { agencyName } retains the right to hold
                                    this registration form and any other data required to
                                    process it and pass onto any authorised third party and the
                                    details held within. I also agree to use all reasonable
                                    efforts to assist to comply with the Data Protection Act
                                    2018.
                                </p>
                                <p>
                                    In addition, I confirm that that all the information
                                    provided is true and accurate and that I have received and
                                    agree to { agencyName } Recruitment terms of engagement
                                    and Staff Handbook.
                                </p>
                                <div className="position-relative p-0  col-12 col-md-4 mt-3 app_declaration">
                                    {/* <div className="form-group">
                                        <Input type="checkbox" />
                                    </div> */}
                                    <CheckBoxInput {...register("declarationAccept")} />
                                        {/* <Input type="date" /> */}
                                    <DateInput parentClassName="col-md-8" name="declarationAcceptDate" handleOnDateChange={handleOnDateChange} value={watch("declarationAcceptDate")}/>

                                </div>
                                {/* <div className="position-relative p-0 col-12 col-md-12 mt-3 mt-10">
                                    <div className="form-group click_button">
                                        <button className="click_sign">Click To Sign</button>
                                    </div>
                                </div> */}

                            </div>
                            <div className="row mx-0">
                                <div className="position-relative col-md-3">
                                    <button type="button" className="sign-modal" onClick={()=>toggleSignModal("signature")}>{!_watch_signature ? "Click to Signature":"Replace the Signature"}</button>
                                </div>
                                <SignatureView signValue={_watch_signature} />
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>

                <div className="position-relative col-12 col-md-12">
                    <div className="text-center three_button" id="s-c-buttons"> 
                        <Button type="button" onClick={()=>toggleTab("submenu", "3")}><i class="fa fa-chevron-circle-left" aria-hidden="true" ></i> Previous </Button>
                        <Button type="submit" className={`btn-save ${formState.isDirty ? "" : "cursor-no-drop"}`} disabled={!formState.isDirty}>Save</Button>
                        <Button type="button" onClick={handleOnContinue} >Continue</Button>
                    </div>
                </div>
            </Form>
        </>
    )
}



const SignatureView = ({signValue=''})=>{
    return signValue &&  <div className="position-relative col-md-4 signzs">
    <label>Signature:</label>
    { 
        signValue && signValue.startsWith('uploads/images/employee') 
        ? <span><img src={`${NodeURL}/${signValue}`} alt='Signature' /></span>
        : <p>{signValue}</p>
    }
</div>
}






const TernaryComponent = ({condition = false ,IFTRUE = <></> , IFFALSE =<></>  }) => condition ? IFTRUE : IFFALSE;










const FileViewDoc = ({ url = '' , onClick = ()=>{} , onDelete = ()=>{}}) => {
    let id = url.replace(/[\/.]/g ,"-")
  return (
    url
    ? <li>
        <span id={id}> <img src={pdf} alt="doc Viewer" onClick={()=>onClick(url)} />     </span>
        <button type="button" onClick={onDelete}><i class="fa fa-trash-o" aria-hidden="true"></i> </button>
        <UncontrolledTooltip placement="bottom" target={id}>View Document</UncontrolledTooltip>
      </li>
    : null
  );
};



// Employment & Education view doc 

const FileViewEmployment = ({ url = '', onClick = () => { }, onDelete = () => { } }) => {
    let id = url.replace(/[\/.]/g ,"-")
    return (
        url
        ? <div className="up_imgs">
            <img id={id} src={pdf} alt="Image_viewer" className="cursor-pointer" onClick={()=>onClick(url)} />
            <button type="button" onClick={()=>onDelete(url)} className="trash-bttn"><i className="fa fa-trash-o cursor-pointer" aria-hidden="true"></i></button>
            <UncontrolledTooltip placement="bottom" target={id}>View Document</UncontrolledTooltip>
          </div>
        : null
    )
}





const SignaturePadModel = ({ isOpen, toggle ,signValue='', onSignature,signTypeId = '' }) => {

    const[activeSign,setActiveSign]=useState("signImg"); // signImg || signtext

    const[signType,setSignType]=useState(signValue && signValue.startsWith('uploads/images/employee')? "": signValue);

    const signCanvas = useRef()

    const toggleSignTab = (tab) => {
        if (activeSign !== tab) {
            setActiveSign(tab);
        }
    };
    const handleOnToggle = ()=>{
        toggle()
        setSignType("")
    }

    const clearSign = (action) => {
        if (action === 'draw' && !signCanvas.current.isEmpty()) {
            signCanvas.current.clear();
        }
        if (action === 'type') {
            setSignType("");
        }
    };
    
  
    const saveSignature = async () => {

        if(activeSign === 'signtext'){
            onSignature(signType ,signTypeId)
            handleOnToggle()
            return
        }
        if (signCanvas.current.isEmpty()) {
            toast.error('Please provide a signature');
        } else {
        const signData = signCanvas.current.getTrimmedCanvas().toDataURL("image/png");
        fetch(signData).then((resp)=>resp.blob()).then(async (signblob)=>{
            const filed = new File([signblob], "png", { type: "image/png" });
            const file_path = await addfileToServer(createFormData({upload_doc:filed}));
            // console.log(filed ,'signblob' , URL.createObjectURL(filed) ,'createObjectURL')
            onSignature(file_path,signTypeId)
            toast.success('Signature Added successfully');
            handleOnToggle();
        })

        }
    }

  return (
    <Modal isOpen={isOpen} toggle={handleOnToggle} centered={true}>
      <ModalBody>
        <div className="cus-senders sign-modal">
          <div className="row ">
            <div className="col-sm-12 col-xs-12">
              <Nav tabs className="nav-pills nav-info horz-tab">
                <NavItem className="nav nav-tabs" id="myTab" role="tablist">
                  <NavLink onClick={() => toggleSignTab('signImg')} className={activeSign==="signImg" ? "activeTabSign":""}>Draw</NavLink>
                </NavItem>
                <NavItem className="nav nav-tabs" id="myTab" role="tablist">
                  <NavLink onClick={() => toggleSignTab('signtext')} className={activeSign==="signtext" ? "activeTabSign":""}>Type</NavLink>
                </NavItem>
              </Nav>
            </div>
            <Col xs="12" md="12">
              <TabContent activeTab={activeSign}>
                <TabPane tabId="signImg">
                  <div className="popup adding_folder">
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h4 className="modal-title" id="myModalLabel">
                            Signature Pad
                          </h4>
                        </div>
                        <div className="modal-body">
                          <div className="sig-container">
                            <div className="sigContainer">
                              <SignaturePad
                                canvasProps={{
                                  width: 500,
                                  height: 200,
                                  className: "sigPad",
                                }}
                                ref={signCanvas}
                              />
                      
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPane>
                <TabPane tabId="signtext">
                  <div className="popup adding_folder">
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h4 className="modal-title" id="myModalLabel">
                            Type Your Signature
                          </h4>
                        </div>
                        <div className="modal-body">
                          <div className="sig-container">
                            <input
                              style={{
                                fontFamily: "Brush Script MT, cursive",
                                fontWeight: "500",
                                fontSize: "25px",
                              }}
                              type="text"
                              name="workingTimeSignatureText"
                              value={signType}
                              onChange={(e)=>setSignType(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPane>
              </TabContent>
            </Col>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="footer-model">
        {activeSign==="signImg" ? 
            (<button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => clearSign('draw')}>Clear</button>) : 
            (<button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => clearSign('type')}>Clear</button>)
        }


        <button type="button" className="btn btn-primary" onClick={saveSignature}>Save</button>


        <Button className="btn btn-secondary" onClick={handleOnToggle}>Cancel</Button>

      </ModalFooter>
    </Modal>
  );
};